(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.cxco = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

if (!Array.prototype.findIndex) {
  Array.prototype.findIndex = function (predicate) {
    if (this === null) {
      throw new TypeError('Array.prototype.findIndex called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return i;
      }
    }
    return -1;
  };
}

// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
  Array.from = function () {
    var toStr = Object.prototype.toString;
    var isCallable = function isCallable(fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function toInteger(value) {
      var number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function toLength(value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method 
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }();
}

if (typeof Object.assign != 'function') {
  Object.assign = function (target, varArgs) {
    // .length of function is 2
    'use strict';

    if (target == null) {
      // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) {
        // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

},{}],2:[function(require,module,exports){
(function (global){
!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var t;t="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,t.basicLightbox=e()}}(function(){return function e(t,n,o){function r(f,c){if(!n[f]){if(!t[f]){var a="function"==typeof require&&require;if(!c&&a)return a(f,!0);if(i)return i(f,!0);var l=new Error("Cannot find module '"+f+"'");throw l.code="MODULE_NOT_FOUND",l}var u=n[f]={exports:{}};t[f][0].call(u.exports,function(e){var n=t[f][1][e];return r(n||e)},u,u.exports,e,t,n,o)}return n[f].exports}for(var i="function"==typeof require&&require,f=0;f<o.length;f++)r(o[f]);return r}({1:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(e){"function"==typeof e.stopPropagation&&e.stopPropagation(),"function"==typeof e.preventDefault&&e.preventDefault()},r=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return e=Object.assign({},e),!1!==e.closable&&(e.closable=!0),"function"==typeof e.className&&(e.className=e.className()),"string"!=typeof e.className&&(e.className=null),"function"!=typeof e.beforeShow&&(e.beforeShow=function(){}),"function"!=typeof e.afterShow&&(e.afterShow=function(){}),"function"!=typeof e.beforeClose&&(e.beforeClose=function(){}),"function"!=typeof e.afterClose&&(e.afterClose=function(){}),"function"==typeof e.beforePlaceholder&&(e.beforePlaceholder=e.beforePlaceholder()),"string"!=typeof e.beforePlaceholder&&(e.beforePlaceholder=""),"function"==typeof e.afterPlaceholder&&(e.afterPlaceholder=e.afterPlaceholder()),"string"!=typeof e.afterPlaceholder&&(e.afterPlaceholder=""),e},i=function(e){var t=e.children;return 1===t.length&&"IMG"===t[0].tagName},f=n.visible=function(e){return null!=(e=e||document.querySelector(".basicLightbox"))&&!0===e.ownerDocument.body.contains(e)},c=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments[1],n=document.createElement("div");return n.classList.add("basicLightbox"),null!=t.className&&n.classList.add(t.className),n.innerHTML="\n\t\t"+t.beforePlaceholder+'\n\t\t<div class="basicLightbox__placeholder" role="dialog">\n\t\t\t'+e+"\n\t\t</div>\n\t\t"+t.afterPlaceholder+"\n\t",!0===i(n.querySelector(".basicLightbox__placeholder"))&&n.classList.add("basicLightbox--img"),n},a=function(e,t){return document.body.appendChild(e),setTimeout(function(){requestAnimationFrame(function(){return e.classList.add("basicLightbox--visible"),t()})},10),!0},l=function(e,t){return e.classList.remove("basicLightbox--visible"),setTimeout(function(){requestAnimationFrame(function(){return!1===f(e)?t():(e.parentElement.removeChild(e),t())})},410),!0};n.create=function(e,t){t=r(t);var n=c(e,t),i=function(){return n},u=function(){return f(n)},s=function(e){return!1!==t.beforeShow(b)&&a(n,function(){if(t.afterShow(b),"function"==typeof e)return e(b)})},d=function(e){return!1!==t.beforeClose(b)&&l(n,function(){if(t.afterClose(b),"function"==typeof e)return e(b)})};!0===t.closable&&(n.onclick=function(e){e.target===this&&(d(),o(e))});var b={element:i,visible:u,show:s,close:d};return b}},{}]},{},[1])(1)});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],3:[function(require,module,exports){
'use strict';
// For more information about browser field, check out the browser field at https://github.com/substack/browserify-handbook#browser-field.

var styleElementsInsertedAtTop = [];

var insertStyleElement = function(styleElement, options) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];

    options = options || {};
    options.insertAt = options.insertAt || 'bottom';

    if (options.insertAt === 'top') {
        if (!lastStyleElementInsertedAtTop) {
            head.insertBefore(styleElement, head.firstChild);
        } else if (lastStyleElementInsertedAtTop.nextSibling) {
            head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
        } else {
            head.appendChild(styleElement);
        }
        styleElementsInsertedAtTop.push(styleElement);
    } else if (options.insertAt === 'bottom') {
        head.appendChild(styleElement);
    } else {
        throw new Error('Invalid value for parameter \'insertAt\'. Must be \'top\' or \'bottom\'.');
    }
};

module.exports = {
    // Create a <link> tag with optional data attributes
    createLink: function(href, attributes) {
        var head = document.head || document.getElementsByTagName('head')[0];
        var link = document.createElement('link');

        link.href = href;
        link.rel = 'stylesheet';

        for (var key in attributes) {
            if ( ! attributes.hasOwnProperty(key)) {
                continue;
            }
            var value = attributes[key];
            link.setAttribute('data-' + key, value);
        }

        head.appendChild(link);
    },
    // Create a <style> tag with optional data attributes
    createStyle: function(cssText, attributes, extraOptions) {
        extraOptions = extraOptions || {};

        var style = document.createElement('style');
        style.type = 'text/css';

        for (var key in attributes) {
            if ( ! attributes.hasOwnProperty(key)) {
                continue;
            }
            var value = attributes[key];
            style.setAttribute('data-' + key, value);
        }

        if (style.sheet) { // for jsdom and IE9+
            style.innerHTML = cssText;
            style.sheet.cssText = cssText;
            insertStyleElement(style, { insertAt: extraOptions.insertAt });
        } else if (style.styleSheet) { // for IE8 and below
            insertStyleElement(style, { insertAt: extraOptions.insertAt });
            style.styleSheet.cssText = cssText;
        } else { // for Chrome, Firefox, and Safari
            style.appendChild(document.createTextNode(cssText));
            insertStyleElement(style, { insertAt: extraOptions.insertAt });
        }
    }
};

},{}],4:[function(require,module,exports){
(function (global,setImmediate){
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.DCX=t()}}(function(){var t;return function e(t,r,n){function i(o,a){if(!r[o]){if(!t[o]){var u="function"==typeof require&&require;if(!a&&u)return u(o,!0);if(s)return s(o,!0);var l=new Error("Cannot find module '"+o+"'");throw l.code="MODULE_NOT_FOUND",l}var c=r[o]={exports:{}};t[o][0].call(c.exports,function(e){var r=t[o][1][e];return i(r?r:e)},c,c.exports,e,t,r,n)}return r[o].exports}for(var s="function"==typeof require&&require,o=0;o<n.length;o++)i(n[o]);return i}({1:[function(t,e,r){"use strict";Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),r=e.length>>>0;if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var n=arguments[1],i=0;i<r;){var s=e[i];if(t.call(n,s,i,e))return s;i++}}})},{}],2:[function(t,e,r){"use strict";var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e.exports=function(t,e,r,i){t=t||"",e=e||{},r=r||"",i=i||function(){};var s=function(t){var e=[];for(var r in t)t.hasOwnProperty(r)&&e.push(r);return e};if("object"==("undefined"==typeof e?"undefined":n(e))){for(var o="",a=s(e),u=0;u<a.length;u++)o+=encodeURIComponent(a[u])+"="+encodeURIComponent(e[a[u]]),u!=a.length-1&&(o+="&");t+="?"+o}else"function"==typeof e&&(r=e,i=r);"function"==typeof r&&(i=r,r="callback"),Date.now||(Date.now=function(){return(new Date).getTime()});var l=Date.now(),c="jsonp"+Math.round(l+1000001*Math.random());window[c]=function(t){i(t);try{delete window[c]}catch(e){window[c]=void 0}},t+=t.indexOf("?")===-1?"?":"&";var p=document.createElement("script");p.setAttribute("src",t+r+"="+c),document.getElementsByTagName("head")[0].appendChild(p)}},{}],3:[function(t,e,r){"use strict";function n(t,e){i.addType(t,function(r,n,o){var a,u,l,c,p=n,d=(new Date).getTime();if(!r){p={},c=[],l=0;try{for(r=e.length;r=e.key(l++);)s.test(r)&&(u=JSON.parse(e.getItem(r)),u.expires&&u.expires<=d?c.push(r):p[r.replace(s,"")]=u.data);for(;r=c.pop();)e.removeItem(r)}catch(f){}return p}if(r="__amplify__"+r,void 0===n){if(a=e.getItem(r),u=a?JSON.parse(a):{expires:-1},!(u.expires&&u.expires<=d))return u.data;e.removeItem(r)}else if(null===n)e.removeItem(r);else{u=JSON.stringify({data:n,expires:o.expires?d+o.expires:null});try{e.setItem(r,u)}catch(f){i[t]();try{e.setItem(r,u)}catch(f){throw i.error()}}}return p})}var i=function(t,e,r){var n=i.type;return r&&r.type&&r.type in i.types&&(n=r.type),i.types[n](t,e,r||{})};i.types={},i.type=null,i.addType=function(t,e){i.type||(i.type=t),i.types[t]=e,i[t]=function(e,r,n){return n=n||{},n.type=t,i(e,r,n)}},i.error=function(){return"amplify.store quota exceeded"};var s=/^__amplify__/;for(var o in{localStorage:1,sessionStorage:1})try{"undefined"!=typeof window&&(window[o].setItem("__amplify__","x"),window[o].removeItem("__amplify__"),n(o,window[o]))}catch(a){}if("undefined"!=typeof window&&!i.types.localStorage&&window.globalStorage)try{n("globalStorage",window.globalStorage[window.location.hostname]),"sessionStorage"===i.type&&(i.type="globalStorage")}catch(a){}!function(){if(!i.types.localStorage&&"undefined"!=typeof window){var t=document.createElement("div"),e="amplify";t.style.display="none",document.getElementsByTagName("head")[0].appendChild(t);try{t.addBehavior("#default#userdata"),t.load(e)}catch(r){return void t.parentNode.removeChild(t)}i.addType("userData",function(r,n,s){t.load(e);var o,a,u,l,c,p=n,d=(new Date).getTime();if(!r){for(p={},c=[],l=0;o=t.XMLDocument.documentElement.attributes[l++];)a=JSON.parse(o.value),a.expires&&a.expires<=d?c.push(o.name):p[o.name]=a.data;for(;r=c.pop();)t.removeAttribute(r);return t.save(e),p}if(r=r.replace(/[^\-._0-9A-Za-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c-\u200d\u203f\u2040\u2070-\u218f]/g,"-"),r=r.replace(/^-/,"_-"),void 0===n){if(o=t.getAttribute(r),a=o?JSON.parse(o):{expires:-1},!(a.expires&&a.expires<=d))return a.data;t.removeAttribute(r)}else null===n?t.removeAttribute(r):(u=t.getAttribute(r),a=JSON.stringify({data:n,expires:s.expires?d+s.expires:null}),t.setAttribute(r,a));try{t.save(e)}catch(f){null===u?t.removeAttribute(r):t.setAttribute(r,u),i.userData();try{t.setAttribute(r,a),t.save(e)}catch(f){throw null===u?t.removeAttribute(r):t.setAttribute(r,u),i.error()}}return p})}}(),function(){function t(t){return void 0===t?void 0:JSON.parse(JSON.stringify(t))}var e={},r={};i.addType("memory",function(n,i,s){return n?void 0===i?t(e[n]):(r[n]&&(clearTimeout(r[n]),delete r[n]),null===i?(delete e[n],null):(e[n]=i,s.expires&&(r[n]=setTimeout(function(){delete e[n],delete r[n]},s.expires)),i)):t(e)})}(),e.exports=i},{}],4:[function(e,r,n){!function(){"use strict";function e(t,r,n){return("string"==typeof r?r:r.toString()).replace(t.define||a,function(e,r,i,s){return 0===r.indexOf("def.")&&(r=r.substring(4)),r in n||(":"===i?(t.defineParams&&s.replace(t.defineParams,function(t,e,i){n[r]={arg:e,text:i}}),r in n||(n[r]=s)):new Function("def","def['"+r+"']="+s)(n)),""}).replace(t.use||a,function(r,i){t.useParams&&(i=i.replace(t.useParams,function(t,e,r,i){if(n[r]&&n[r].arg&&i){var s=(r+":"+i).replace(/'|\\/g,"_");return n.__exp=n.__exp||{},n.__exp[s]=n[r].text.replace(new RegExp("(^|[^\\w$])"+n[r].arg+"([^\\w$])","g"),"$1"+i+"$2"),e+"def.__exp['"+s+"']"}}));var s=new Function("def","return "+i)(n);return s?e(t,s,n):s})}function n(t){return t.replace(/\\('|\\)/g,"$1").replace(/[\r\t\n]/g," ")}var i,s={name:"doT",version:"1.1.1",templateSettings:{evaluate:/\{\{([\s\S]+?(\}?)+)\}\}/g,interpolate:/\{\{=([\s\S]+?)\}\}/g,encode:/\{\{!([\s\S]+?)\}\}/g,use:/\{\{#([\s\S]+?)\}\}/g,useParams:/(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,define:/\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,defineParams:/^\s*([\w$]+):([\s\S]+)/,conditional:/\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,iterate:/\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,varname:"it",strip:!0,append:!0,selfcontained:!1,doNotSkipEncoded:!1},template:void 0,compile:void 0,log:!0};s.encodeHTMLSource=function(t){var e={"&":"&#38;","<":"&#60;",">":"&#62;",'"':"&#34;","'":"&#39;","/":"&#47;"},r=t?/[&<>"'\/]/g:/&(?!#?\w+;)|<|>|"|'|\//g;return function(t){return t?t.toString().replace(r,function(t){return e[t]||t}):""}},i=function(){return this||(0,eval)("this")}(),"undefined"!=typeof r&&r.exports?r.exports=s:"function"==typeof t&&t.amd?t(function(){return s}):i.doT=s;var o={append:{start:"'+(",end:")+'",startencode:"'+encodeHTML("},split:{start:"';out+=(",end:");out+='",startencode:"';out+=encodeHTML("}},a=/$^/;s.template=function(t,r,u){r=r||s.templateSettings;var l,c,p=r.append?o.append:o.split,d=0,f=r.use||r.define?e(r,t,u||{}):t;f=("var out='"+(r.strip?f.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g," ").replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g,""):f).replace(/'|\\/g,"\\$&").replace(r.interpolate||a,function(t,e){return p.start+n(e)+p.end}).replace(r.encode||a,function(t,e){return l=!0,p.startencode+n(e)+p.end}).replace(r.conditional||a,function(t,e,r){return e?r?"';}else if("+n(r)+"){out+='":"';}else{out+='":r?"';if("+n(r)+"){out+='":"';}out+='"}).replace(r.iterate||a,function(t,e,r,i){return e?(d+=1,c=i||"i"+d,e=n(e),"';var arr"+d+"="+e+";if(arr"+d+"){var "+r+","+c+"=-1,l"+d+"=arr"+d+".length-1;while("+c+"<l"+d+"){"+r+"=arr"+d+"["+c+"+=1];out+='"):"';} } out+='"}).replace(r.evaluate||a,function(t,e){return"';"+n(e)+"out+='"})+"';return out;").replace(/\n/g,"\\n").replace(/\t/g,"\\t").replace(/\r/g,"\\r").replace(/(\s|;|\}|^|\{)out\+='';/g,"$1").replace(/\+''/g,""),l&&(r.selfcontained||!i||i._encodeHTML||(i._encodeHTML=s.encodeHTMLSource(r.doNotSkipEncoded)),f="var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : ("+s.encodeHTMLSource.toString()+"("+(r.doNotSkipEncoded||"")+"));"+f);try{return new Function(r.varname,f)}catch(h){throw"undefined"!=typeof console&&console.log("Could not create a template function: "+f),h}},s.compile=function(t,e){return s.template(t,null,e)}}()},{}],5:[function(e,r,n){(function(e){(function(){function e(t){this.tokens=[],this.tokens.links={},this.options=t||d.defaults,this.rules=f.normal,this.options.gfm&&(this.options.tables?this.rules=f.tables:this.rules=f.gfm)}function i(t,e){if(this.options=e||d.defaults,this.links=t,this.rules=h.normal,this.renderer=this.options.renderer||new s,this.renderer.options=this.options,!this.links)throw new Error("Tokens array requires a `links` property.");this.options.gfm?this.options.breaks?this.rules=h.breaks:this.rules=h.gfm:this.options.pedantic&&(this.rules=h.pedantic)}function s(t){this.options=t||{}}function o(t){this.tokens=[],this.token=null,this.options=t||d.defaults,this.options.renderer=this.options.renderer||new s,this.renderer=this.options.renderer,this.renderer.options=this.options}function a(t,e){return t.replace(e?/&/g:/&(?!#?\w+;)/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function u(t){return t.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(t,e){return e=e.toLowerCase(),"colon"===e?":":"#"===e.charAt(0)?"x"===e.charAt(1)?String.fromCharCode(parseInt(e.substring(2),16)):String.fromCharCode(+e.substring(1)):""})}function l(t,e){return t=t.source,e=e||"",function r(n,i){return n?(i=i.source||i,i=i.replace(/(^|[^\[])\^/g,"$1"),t=t.replace(n,i),r):new RegExp(t,e)}}function c(){}function p(t){for(var e,r,n=1;n<arguments.length;n++){e=arguments[n];for(r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r])}return t}function d(t,r,n){if(n||"function"==typeof r){n||(n=r,r=null),r=p({},d.defaults,r||{});var i,s,u=r.highlight,l=0;try{i=e.lex(t,r)}catch(c){return n(c)}s=i.length;var f=function(t){if(t)return r.highlight=u,n(t);var e;try{e=o.parse(i,r)}catch(s){t=s}return r.highlight=u,t?n(t):n(null,e)};if(!u||u.length<3)return f();if(delete r.highlight,!s)return f();for(;l<i.length;l++)!function(t){return"code"!==t.type?--s||f():u(t.text,t.lang,function(e,r){return e?f(e):null==r||r===t.text?--s||f():(t.text=r,t.escaped=!0,void(--s||f()))})}(i[l])}else try{return r&&(r=p({},d.defaults,r)),o.parse(e.lex(t,r),r)}catch(c){if(c.message+="\nPlease report this to https://github.com/chjj/marked.",(r||d.defaults).silent)return"<p>An error occured:</p><pre>"+a(c.message+"",!0)+"</pre>";throw c}}var f={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:c,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:c,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:c,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};f.bullet=/(?:[*+-]|\d+\.)/,f.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/,f.item=l(f.item,"gm")(/bull/g,f.bullet)(),f.list=l(f.list)(/bull/g,f.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+f.def.source+")")(),f.blockquote=l(f.blockquote)("def",f.def)(),f._tag="(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b",f.html=l(f.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,f._tag)(),f.paragraph=l(f.paragraph)("hr",f.hr)("heading",f.heading)("lheading",f.lheading)("blockquote",f.blockquote)("tag","<"+f._tag)("def",f.def)(),f.normal=p({},f),f.gfm=p({},f.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/}),f.gfm.paragraph=l(f.paragraph)("(?!","(?!"+f.gfm.fences.source.replace("\\1","\\2")+"|"+f.list.source.replace("\\1","\\3")+"|")(),f.tables=p({},f.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/}),e.rules=f,e.lex=function(t,r){var n=new e(r);return n.lex(t)},e.prototype.lex=function(t){return t=t.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n"),this.token(t,!0)},e.prototype.token=function(t,e,r){for(var n,i,s,o,a,u,l,c,p,t=t.replace(/^ +$/gm,"");t;)if((s=this.rules.newline.exec(t))&&(t=t.substring(s[0].length),s[0].length>1&&this.tokens.push({type:"space"})),s=this.rules.code.exec(t))t=t.substring(s[0].length),s=s[0].replace(/^ {4}/gm,""),this.tokens.push({type:"code",text:this.options.pedantic?s:s.replace(/\n+$/,"")});else if(s=this.rules.fences.exec(t))t=t.substring(s[0].length),this.tokens.push({type:"code",lang:s[2],text:s[3]||""});else if(s=this.rules.heading.exec(t))t=t.substring(s[0].length),this.tokens.push({type:"heading",depth:s[1].length,text:s[2]});else if(e&&(s=this.rules.nptable.exec(t))){for(t=t.substring(s[0].length),u={type:"table",header:s[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:s[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:s[3].replace(/\n$/,"").split("\n")},c=0;c<u.align.length;c++)/^ *-+: *$/.test(u.align[c])?u.align[c]="right":/^ *:-+: *$/.test(u.align[c])?u.align[c]="center":/^ *:-+ *$/.test(u.align[c])?u.align[c]="left":u.align[c]=null;for(c=0;c<u.cells.length;c++)u.cells[c]=u.cells[c].split(/ *\| */);this.tokens.push(u)}else if(s=this.rules.lheading.exec(t))t=t.substring(s[0].length),this.tokens.push({type:"heading",depth:"="===s[2]?1:2,text:s[1]});else if(s=this.rules.hr.exec(t))t=t.substring(s[0].length),this.tokens.push({type:"hr"});else if(s=this.rules.blockquote.exec(t))t=t.substring(s[0].length),this.tokens.push({type:"blockquote_start"}),s=s[0].replace(/^ *> ?/gm,""),this.token(s,e,!0),this.tokens.push({type:"blockquote_end"});else if(s=this.rules.list.exec(t)){for(t=t.substring(s[0].length),o=s[2],this.tokens.push({type:"list_start",ordered:o.length>1}),s=s[0].match(this.rules.item),n=!1,p=s.length,c=0;c<p;c++)u=s[c],l=u.length,u=u.replace(/^ *([*+-]|\d+\.) +/,""),~u.indexOf("\n ")&&(l-=u.length,u=this.options.pedantic?u.replace(/^ {1,4}/gm,""):u.replace(new RegExp("^ {1,"+l+"}","gm"),"")),this.options.smartLists&&c!==p-1&&(a=f.bullet.exec(s[c+1])[0],o===a||o.length>1&&a.length>1||(t=s.slice(c+1).join("\n")+t,c=p-1)),i=n||/\n\n(?!\s*$)/.test(u),c!==p-1&&(n="\n"===u.charAt(u.length-1),i||(i=n)),this.tokens.push({type:i?"loose_item_start":"list_item_start"}),this.token(u,!1,r),this.tokens.push({type:"list_item_end"});this.tokens.push({type:"list_end"})}else if(s=this.rules.html.exec(t))t=t.substring(s[0].length),this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&("pre"===s[1]||"script"===s[1]||"style"===s[1]),text:s[0]});else if(!r&&e&&(s=this.rules.def.exec(t)))t=t.substring(s[0].length),this.tokens.links[s[1].toLowerCase()]={href:s[2],title:s[3]};else if(e&&(s=this.rules.table.exec(t))){for(t=t.substring(s[0].length),u={type:"table",header:s[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:s[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:s[3].replace(/(?: *\| *)?\n$/,"").split("\n")},c=0;c<u.align.length;c++)/^ *-+: *$/.test(u.align[c])?u.align[c]="right":/^ *:-+: *$/.test(u.align[c])?u.align[c]="center":/^ *:-+ *$/.test(u.align[c])?u.align[c]="left":u.align[c]=null;for(c=0;c<u.cells.length;c++)u.cells[c]=u.cells[c].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */);this.tokens.push(u)}else if(e&&(s=this.rules.paragraph.exec(t)))t=t.substring(s[0].length),this.tokens.push({type:"paragraph",text:"\n"===s[1].charAt(s[1].length-1)?s[1].slice(0,-1):s[1]});else if(s=this.rules.text.exec(t))t=t.substring(s[0].length),this.tokens.push({type:"text",text:s[0]});else if(t)throw new Error("Infinite loop on byte: "+t.charCodeAt(0));return this.tokens};var h={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:c,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:c,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};h._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/,h._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/,h.link=l(h.link)("inside",h._inside)("href",h._href)(),h.reflink=l(h.reflink)("inside",h._inside)(),h.normal=p({},h),h.pedantic=p({},h.normal,{strong:/^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/}),h.gfm=p({},h.normal,{escape:l(h.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:l(h.text)("]|","~]|")("|","|https?://|")()}),h.breaks=p({},h.gfm,{br:l(h.br)("{2,}","*")(),text:l(h.gfm.text)("{2,}","*")()}),i.rules=h,i.output=function(t,e,r){var n=new i(e,r);return n.output(t)},i.prototype.output=function(t){for(var e,r,n,i,s="";t;)if(i=this.rules.escape.exec(t))t=t.substring(i[0].length),s+=i[1];else if(i=this.rules.autolink.exec(t))t=t.substring(i[0].length),"@"===i[2]?(r=":"===i[1].charAt(6)?this.mangle(i[1].substring(7)):this.mangle(i[1]),n=this.mangle("mailto:")+r):(r=a(i[1]),n=r),s+=this.renderer.link(n,null,r);else if(this.inLink||!(i=this.rules.url.exec(t))){if(i=this.rules.tag.exec(t))!this.inLink&&/^<a /i.test(i[0])?this.inLink=!0:this.inLink&&/^<\/a>/i.test(i[0])&&(this.inLink=!1),t=t.substring(i[0].length),s+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(i[0]):a(i[0]):i[0];else if(i=this.rules.link.exec(t))t=t.substring(i[0].length),this.inLink=!0,s+=this.outputLink(i,{href:i[2],title:i[3]}),this.inLink=!1;else if((i=this.rules.reflink.exec(t))||(i=this.rules.nolink.exec(t))){if(t=t.substring(i[0].length),e=(i[2]||i[1]).replace(/\s+/g," "),e=this.links[e.toLowerCase()],!e||!e.href){s+=i[0].charAt(0),t=i[0].substring(1)+t;continue}this.inLink=!0,s+=this.outputLink(i,e),this.inLink=!1}else if(i=this.rules.strong.exec(t))t=t.substring(i[0].length),s+=this.renderer.strong(this.output(i[2]||i[1]));else if(i=this.rules.em.exec(t))t=t.substring(i[0].length),s+=this.renderer.em(this.output(i[2]||i[1]));else if(i=this.rules.code.exec(t))t=t.substring(i[0].length),s+=this.renderer.codespan(a(i[2],!0));else if(i=this.rules.br.exec(t))t=t.substring(i[0].length),s+=this.renderer.br();else if(i=this.rules.del.exec(t))t=t.substring(i[0].length),s+=this.renderer.del(this.output(i[1]));else if(i=this.rules.text.exec(t))t=t.substring(i[0].length),s+=this.renderer.text(a(this.smartypants(i[0])));else if(t)throw new Error("Infinite loop on byte: "+t.charCodeAt(0))}else t=t.substring(i[0].length),r=a(i[1]),n=r,s+=this.renderer.link(n,null,r);return s},i.prototype.outputLink=function(t,e){var r=a(e.href),n=e.title?a(e.title):null;return"!"!==t[0].charAt(0)?this.renderer.link(r,n,this.output(t[1])):this.renderer.image(r,n,a(t[1]))},i.prototype.smartypants=function(t){return this.options.smartypants?t.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…"):t},i.prototype.mangle=function(t){if(!this.options.mangle)return t;for(var e,r="",n=t.length,i=0;i<n;i++)e=t.charCodeAt(i),Math.random()>.5&&(e="x"+e.toString(16)),r+="&#"+e+";";return r},s.prototype.code=function(t,e,r){if(this.options.highlight){var n=this.options.highlight(t,e);null!=n&&n!==t&&(r=!0,t=n)}return e?'<pre><code class="'+this.options.langPrefix+a(e,!0)+'">'+(r?t:a(t,!0))+"\n</code></pre>\n":"<pre><code>"+(r?t:a(t,!0))+"\n</code></pre>"},s.prototype.blockquote=function(t){return"<blockquote>\n"+t+"</blockquote>\n"},s.prototype.html=function(t){return t},s.prototype.heading=function(t,e,r){return"<h"+e+' id="'+this.options.headerPrefix+r.toLowerCase().replace(/[^\w]+/g,"-")+'">'+t+"</h"+e+">\n"},s.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"},s.prototype.list=function(t,e){var r=e?"ol":"ul";return"<"+r+">\n"+t+"</"+r+">\n"},s.prototype.listitem=function(t){return"<li>"+t+"</li>\n"},s.prototype.paragraph=function(t){return"<p>"+t+"</p>\n"},s.prototype.table=function(t,e){return"<table>\n<thead>\n"+t+"</thead>\n<tbody>\n"+e+"</tbody>\n</table>\n"},s.prototype.tablerow=function(t){return"<tr>\n"+t+"</tr>\n"},s.prototype.tablecell=function(t,e){var r=e.header?"th":"td",n=e.align?"<"+r+' style="text-align:'+e.align+'">':"<"+r+">";return n+t+"</"+r+">\n"},s.prototype.strong=function(t){return"<strong>"+t+"</strong>"},s.prototype.em=function(t){return"<em>"+t+"</em>"},s.prototype.codespan=function(t){return"<code>"+t+"</code>"},s.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"},s.prototype.del=function(t){return"<del>"+t+"</del>"},s.prototype.link=function(t,e,r){if(this.options.sanitize){try{var n=decodeURIComponent(u(t)).replace(/[^\w:]/g,"").toLowerCase()}catch(i){return""}if(0===n.indexOf("javascript:")||0===n.indexOf("vbscript:"))return""}var s='<a href="'+t+'"';return e&&(s+=' title="'+e+'"'),s+=">"+r+"</a>"},s.prototype.image=function(t,e,r){var n='<img src="'+t+'" alt="'+r+'"';return e&&(n+=' title="'+e+'"'),n+=this.options.xhtml?"/>":">"},s.prototype.text=function(t){return t},o.parse=function(t,e,r){var n=new o(e,r);return n.parse(t)},o.prototype.parse=function(t){this.inline=new i(t.links,this.options,this.renderer),this.tokens=t.reverse();for(var e="";this.next();)e+=this.tok();return e},o.prototype.next=function(){return this.token=this.tokens.pop()},o.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0},o.prototype.parseText=function(){for(var t=this.token.text;"text"===this.peek().type;)t+="\n"+this.next().text;return this.inline.output(t)},o.prototype.tok=function(){switch(this.token.type){case"space":return"";case"hr":return this.renderer.hr();case"heading":return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text);case"code":return this.renderer.code(this.token.text,this.token.lang,this.token.escaped);case"table":var t,e,r,n,i,s="",o="";for(r="",t=0;t<this.token.header.length;t++)n={header:!0,align:this.token.align[t]},r+=this.renderer.tablecell(this.inline.output(this.token.header[t]),{header:!0,align:this.token.align[t]});for(s+=this.renderer.tablerow(r),t=0;t<this.token.cells.length;t++){for(e=this.token.cells[t],r="",i=0;i<e.length;i++)r+=this.renderer.tablecell(this.inline.output(e[i]),{header:!1,align:this.token.align[i]});o+=this.renderer.tablerow(r)}return this.renderer.table(s,o);case"blockquote_start":for(var o="";"blockquote_end"!==this.next().type;)o+=this.tok();return this.renderer.blockquote(o);case"list_start":for(var o="",a=this.token.ordered;"list_end"!==this.next().type;)o+=this.tok();return this.renderer.list(o,a);case"list_item_start":for(var o="";"list_item_end"!==this.next().type;)o+="text"===this.token.type?this.parseText():this.tok();return this.renderer.listitem(o);case"loose_item_start":for(var o="";"list_item_end"!==this.next().type;)o+=this.tok();return this.renderer.listitem(o);case"html":var u=this.token.pre||this.options.pedantic?this.token.text:this.inline.output(this.token.text);return this.renderer.html(u);case"paragraph":return this.renderer.paragraph(this.inline.output(this.token.text));case"text":return this.renderer.paragraph(this.parseText())}},c.exec=c,d.options=d.setOptions=function(t){return p(d.defaults,t),d},d.defaults={gfm:!0,tables:!0,breaks:!1,pedantic:!1,sanitize:!1,sanitizer:null,mangle:!0,smartLists:!1,silent:!1,highlight:null,langPrefix:"lang-",smartypants:!1,headerPrefix:"",renderer:new s,xhtml:!1},d.Parser=o,d.parser=o.parse,d.Renderer=s,d.Lexer=e,d.lexer=e.lex,d.InlineLexer=i,d.inlineLexer=i.output,d.parse=d,"undefined"!=typeof r&&"object"==typeof n?r.exports=d:"function"==typeof t&&t.amd?t(function(){return d}):this.marked=d}).call(function(){return this||("undefined"!=typeof window?window:e)}())}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],6:[function(t,e,r){!function(t){function r(t,e){return function(){t.apply(e,arguments)}}function n(t){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=null,this._value=null,this._deferreds=[],l(t,r(s,this),r(o,this))}function i(t){var e=this;return null===this._state?void this._deferreds.push(t):void p(function(){var r=e._state?t.onFulfilled:t.onRejected;if(null===r)return void(e._state?t.resolve:t.reject)(e._value);var n;try{n=r(e._value)}catch(i){return void t.reject(i)}t.resolve(n)})}function s(t){try{if(t===this)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var e=t.then;if("function"==typeof e)return void l(r(e,t),r(s,this),r(o,this))}this._state=!0,this._value=t,a.call(this)}catch(n){o.call(this,n)}}function o(t){this._state=!1,this._value=t,a.call(this)}function a(){for(var t=0,e=this._deferreds.length;t<e;t++)i.call(this,this._deferreds[t]);this._deferreds=null}function u(t,e,r,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.resolve=r,this.reject=n}function l(t,e,r){var n=!1;try{t(function(t){n||(n=!0,e(t))},function(t){n||(n=!0,r(t))})}catch(i){if(n)return;n=!0,r(i)}}var c=setTimeout,p="function"==typeof setImmediate&&setImmediate||function(t){c(t,1)},d=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)};n.prototype["catch"]=function(t){return this.then(null,t)},n.prototype.then=function(t,e){var r=this;return new n(function(n,s){i.call(r,new u(t,e,n,s))})},n.all=function(){var t=Array.prototype.slice.call(1===arguments.length&&d(arguments[0])?arguments[0]:arguments);return new n(function(e,r){function n(s,o){try{if(o&&("object"==typeof o||"function"==typeof o)){var a=o.then;if("function"==typeof a)return void a.call(o,function(t){n(s,t)},r)}t[s]=o,0===--i&&e(t)}catch(u){r(u)}}if(0===t.length)return e([]);for(var i=t.length,s=0;s<t.length;s++)n(s,t[s])})},n.resolve=function(t){return t&&"object"==typeof t&&t.constructor===n?t:new n(function(e){e(t)})},n.reject=function(t){return new n(function(e,r){r(t)})},n.race=function(t){return new n(function(e,r){for(var n=0,i=t.length;n<i;n++)t[n].then(e,r)})},n._setImmediateFn=function(t){p=t},"undefined"!=typeof e&&e.exports?e.exports=n:t.Promise||(t.Promise=n)}(this)},{}],7:[function(t,e,r){!function(t){"use strict";function e(t){if("string"!=typeof t&&(t=String(t)),/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(t))throw new TypeError("Invalid character in header field name");return t.toLowerCase()}function r(t){return"string"!=typeof t&&(t=String(t)),t}function n(t){var e={next:function(){var e=t.shift();return{done:void 0===e,value:e}}};return y.iterable&&(e[Symbol.iterator]=function(){return e}),e}function i(t){this.map={},t instanceof i?t.forEach(function(t,e){this.append(e,t)},this):t&&Object.getOwnPropertyNames(t).forEach(function(e){this.append(e,t[e])},this)}function s(t){return t.bodyUsed?Promise.reject(new TypeError("Already read")):void(t.bodyUsed=!0)}function o(t){return new Promise(function(e,r){t.onload=function(){e(t.result)},t.onerror=function(){r(t.error)}})}function a(t){var e=new FileReader,r=o(e);return e.readAsArrayBuffer(t),r}function u(t){var e=new FileReader,r=o(e);return e.readAsText(t),r}function l(t){for(var e=new Uint8Array(t),r=new Array(e.length),n=0;n<e.length;n++)r[n]=String.fromCharCode(e[n]);return r.join("")}function c(t){if(t.slice)return t.slice(0);var e=new Uint8Array(t.byteLength);return e.set(new Uint8Array(t)),e.buffer}function p(){return this.bodyUsed=!1,this._initBody=function(t){if(this._bodyInit=t,t)if("string"==typeof t)this._bodyText=t;else if(y.blob&&Blob.prototype.isPrototypeOf(t))this._bodyBlob=t;else if(y.formData&&FormData.prototype.isPrototypeOf(t))this._bodyFormData=t;else if(y.searchParams&&URLSearchParams.prototype.isPrototypeOf(t))this._bodyText=t.toString();else if(y.arrayBuffer&&y.blob&&v(t))this._bodyArrayBuffer=c(t.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer]);else{if(!y.arrayBuffer||!ArrayBuffer.prototype.isPrototypeOf(t)&&!w(t))throw new Error("unsupported BodyInit type");this._bodyArrayBuffer=c(t)}else this._bodyText="";this.headers.get("content-type")||("string"==typeof t?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):y.searchParams&&URLSearchParams.prototype.isPrototypeOf(t)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},y.blob&&(this.blob=function(){var t=s(this);if(t)return t;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this._bodyArrayBuffer?s(this)||Promise.resolve(this._bodyArrayBuffer):this.blob().then(a)}),this.text=function(){var t=s(this);if(t)return t;if(this._bodyBlob)return u(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(l(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},y.formData&&(this.formData=function(){return this.text().then(h)}),this.json=function(){return this.text().then(JSON.parse)},this}function d(t){var e=t.toUpperCase();return x.indexOf(e)>-1?e:t}function f(t,e){e=e||{};var r=e.body;if("string"==typeof t)this.url=t;else{if(t.bodyUsed)throw new TypeError("Already read");this.url=t.url,this.credentials=t.credentials,e.headers||(this.headers=new i(t.headers)),this.method=t.method,this.mode=t.mode,r||null==t._bodyInit||(r=t._bodyInit,t.bodyUsed=!0)}if(this.credentials=e.credentials||this.credentials||"omit",!e.headers&&this.headers||(this.headers=new i(e.headers)),this.method=d(e.method||this.method||"GET"),this.mode=e.mode||this.mode||null,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&r)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(r)}function h(t){var e=new FormData;return t.trim().split("&").forEach(function(t){if(t){var r=t.split("="),n=r.shift().replace(/\+/g," "),i=r.join("=").replace(/\+/g," ");e.append(decodeURIComponent(n),decodeURIComponent(i))}}),e}function g(t){var e=new i;return t.split("\r\n").forEach(function(t){var r=t.split(":"),n=r.shift().trim();if(n){var i=r.join(":").trim();e.append(n,i)}}),e}function m(t,e){e||(e={}),this.type="default",this.status="status"in e?e.status:200,this.ok=this.status>=200&&this.status<300,this.statusText="statusText"in e?e.statusText:"OK",this.headers=new i(e.headers),this.url=e.url||"",this._initBody(t)}if(!t.fetch){var y={searchParams:"URLSearchParams"in t,iterable:"Symbol"in t&&"iterator"in Symbol,blob:"FileReader"in t&&"Blob"in t&&function(){try{return new Blob,!0}catch(t){return!1}}(),formData:"FormData"in t,arrayBuffer:"ArrayBuffer"in t};if(y.arrayBuffer)var b=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],v=function(t){return t&&DataView.prototype.isPrototypeOf(t)},w=ArrayBuffer.isView||function(t){return t&&b.indexOf(Object.prototype.toString.call(t))>-1;
};i.prototype.append=function(t,n){t=e(t),n=r(n);var i=this.map[t];i||(i=[],this.map[t]=i),i.push(n)},i.prototype["delete"]=function(t){delete this.map[e(t)]},i.prototype.get=function(t){var r=this.map[e(t)];return r?r[0]:null},i.prototype.getAll=function(t){return this.map[e(t)]||[]},i.prototype.has=function(t){return this.map.hasOwnProperty(e(t))},i.prototype.set=function(t,n){this.map[e(t)]=[r(n)]},i.prototype.forEach=function(t,e){Object.getOwnPropertyNames(this.map).forEach(function(r){this.map[r].forEach(function(n){t.call(e,n,r,this)},this)},this)},i.prototype.keys=function(){var t=[];return this.forEach(function(e,r){t.push(r)}),n(t)},i.prototype.values=function(){var t=[];return this.forEach(function(e){t.push(e)}),n(t)},i.prototype.entries=function(){var t=[];return this.forEach(function(e,r){t.push([r,e])}),n(t)},y.iterable&&(i.prototype[Symbol.iterator]=i.prototype.entries);var x=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];f.prototype.clone=function(){return new f(this,{body:this._bodyInit})},p.call(f.prototype),p.call(m.prototype),m.prototype.clone=function(){return new m(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new i(this.headers),url:this.url})},m.error=function(){var t=new m(null,{status:0,statusText:""});return t.type="error",t};var k=[301,302,303,307,308];m.redirect=function(t,e){if(k.indexOf(e)===-1)throw new RangeError("Invalid status code");return new m(null,{status:e,headers:{location:t}})},t.Headers=i,t.Request=f,t.Response=m,t.fetch=function(t,e){return new Promise(function(r,n){var i=new f(t,e),s=new XMLHttpRequest;s.onload=function(){var t={status:s.status,statusText:s.statusText,headers:g(s.getAllResponseHeaders()||"")};t.url="responseURL"in s?s.responseURL:t.headers.get("X-Request-URL");var e="response"in s?s.response:s.responseText;r(new m(e,t))},s.onerror=function(){n(new TypeError("Network request failed"))},s.ontimeout=function(){n(new TypeError("Network request failed"))},s.open(i.method,i.url,!0),"include"===i.credentials&&(s.withCredentials=!0),"responseType"in s&&y.blob&&(s.responseType="blob"),i.headers.forEach(function(t,e){s.setRequestHeader(e,t)}),s.send("undefined"==typeof i._bodyInit?null:i._bodyInit)})},t.fetch.polyfill=!0}}("undefined"!=typeof self?self:this)},{}],8:[function(t,e,r){"use strict";var n=[],i=t("../utils.js"),s=t("./engine.js"),o=t("./hooks.js"),a=t("dot"),u=t("../templates/categorybox.html"),l=t("./storage.js");e.exports=function(t,e,r){function c(t){if(i.isElement(t)&&t.hasAttribute("data-dcx-category")){var e=t.hasAttribute("data-showfaqs")&&"true"==t.getAttribute("data-showfaqs");p(t.getAttribute("data-dcx-category"),e)}}function p(t,e){E("loadCategory",t,e).then(function(){if(t=parseInt(t,10),!isNaN(t))return{classificationId:S.classificationId,categoryId:t}}).then(function(t){return O("loadCategory",t,e)})}function d(t){return E("loadCategories",t).then(function(){if(!i.isNullOrUndefined(t.classificationId)&&!isNaN(parseInt(t.classificationId,10)))return s.getCategories(t)}).then(function(e){return f(e,t)})}function f(t,e){var r={};r.classificationId=e.classificationId;var n=A.indexOf(JSON.stringify(r));n===-1&&(n=A.push(JSON.stringify(r))-1),T[n]={result:t.result,interactionId:t.interactionId},m(T[n],e)}function h(t){t=t||{};var e={};if(i.isNullOrUndefined(t.classificationId)||isNaN(t.classificationId))throw new Error("First parameter missing property classificationId");S.classificationId=t.classificationId,e.classificationId=t.classificationId;var r=A.indexOf(JSON.stringify(e));return r===-1?d(t):m(T[r],t)}function g(t,e){for(var r=0;r<t.length;r++){if(parseInt(t[r].id,10)===e)return t[r];if(t[r].subCategories.length>0){var n=g(t[r].subCategories,e);if(n)return n}}}function m(t,e){if(!i.isNullOrUndefined(e.categoryId)&&!isNaN(e.categoryId)){var r=g(t.result,e.categoryId);t={result:[],interactionId:t.interactionId},r&&i.isArray(r.subCategories)&&(t.result=r.subCategories)}return y(t)}function y(t){return E("showCategories",t).then(function(){var e=a.template(S.template);return N.list.innerHTML=e(t.result),t}).then(function(t){return O("showCategories",t)})}function b(){N.list.innerHTML=""}function v(t){i.isElement(N.list)&&N.list.addEventListener("click",function(e){i.checkEventPropagation(t,e.target,"[data-dcx-category]")&&c(e.target)})}function w(t){N.list=t.querySelector("[data-dcx-categorylist-list]")}function x(){var e=n.indexOf(t);e>-1&&n.splice(e,1)}if(r=r||{},!i.isString(t))throw new Error("First argument expected to be a String");if(t="categorybox__"+t,n.indexOf(t)>-1)throw new Error('categoryBox with id: "'+t+'" already exists');if(i.isString(e)&&(e=document.querySelector(e)),!i.isElement(e))throw new Error("Missing rootElement!");var k=l(t),q={template:u},S=i.extend(q,r),j=o({preLoadCategory:function(){},postLoadCategory:function(){},preLoadCategories:function(){},preShowCategories:function(){},postShowCategories:function(){}}),E=j.before,O=j.after,I=j.off,_=j.on,N={list:null},T={},A=[];return function(){w(e),v(e),i.isNumber(S.classificationId)&&h(S),n.push(t)}(),{id:t,element:e,on:i.wrap(_),off:i.wrap(I),loadCategoryList:i.wrap(h),setCategoryList:i.wrap(f),clearCategoryList:i.wrap(b),sendSystemEvent:i.wrap(s.sendEvent),storage:{store:i.wrap(k.store),remove:i.wrap(k.remove)},history:{get:i.wrap(k.getHistory),filter:i.wrap(k.filterHistory),last:i.wrap(k.lastHistory),clear:i.wrap(k.clearHistory),remove:i.wrap(k.removeHistory)},destroy:i.wrap(x)}}},{"../templates/categorybox.html":22,"../utils.js":29,"./engine.js":9,"./hooks.js":13,"./storage.js":19,dot:4}],9:[function(t,e,r){"use strict";var n=t("../utils.js"),i=t("marked"),s=t("dot"),o=(t("./link.js"),t("../templates/va-link.html")),a=t("./request.js"),u=t("./globalStorage.js"),l=t("./session.js"),c=t("../templates/dialog-option.html");e.exports=function(){function t(t,e,r){return n.isArray(e)&&e.forEach(function(e){if(n.isObject(e)){var i=s.template(o),a=i(n.extend({},e,{interactionId:r})),u=new RegExp("%\\{Link\\("+e.id+"\\)\\}","gi");t=t.replace(u,a)}}),t}function e(t,e,r){n.isObject(t.result)&&(t=t.result);var s={originalResult:t||{}};s.answers=[],s.outputType=t.outputType||"TDialog",s.dialogId=t.dialogId,s.isEndSlot=t.isEnd,s.okMessages=t.okMessages.map(function(t){var e="";return e=i(t.text),e=e.replace(/&lt;(\/?u)&gt;/g,"<$1>"),e=p(e,t,s),{answer:e,additions:t.metadata,images:t.images||[],videos:t.videos||[]}}),s.quickReplies=t.quickReplies||[],s.returnEvent=t.returnEvent||"",s.slots=t.slots||[];var o="";return o=i(t.messageResult.text),o=o.replace(/&lt;(\/?u)&gt;/g,"<$1>"),o=p(o,t.messageResult,s),s.answer=o,s.additions=t.metadata,s.images=t.messageResult.images||[],s.videos=t.messageResult.videos||[],s.answers.push({answer:s.answer,additions:s.metadata,images:s.images,videos:s.videos}),s}function r(t,r,s){if(n.isObject(t)&&t.outputType&&"TDialog"===t.outputType)return e(t,r,s);var o={originalResult:t||{}},a=[];if(o.answers=[],o.faqs=[],o.inputType=r||"",o.interactionId=t.interactionId,o.outputType="answer",o.context=s.context||{},n.isObject(t.traceOutputInformation)&&(o.traceOutputInformation=t.traceOutputInformation),n.isArray(t.outputs)){if(a=t.outputs,a.length>0&&!n.isNullOrUndefined(a[0].dialogPath)){var u=a[0].dialogPath;o.outputType="dialog",o.isDialogStart=!/\//.test(u),o.isDialogEnd=/\!$/.test(u),o.dialogPath=u,o.dialogId=parseInt(u.replace(/^([0-9]+):(.*)/gi,"$1"),10)}a.length>0&&!n.isNullOrUndefined(a[0].interactionValue)&&(o.interactionValue=a[0].interactionValue),a.length>0&&!n.isNullOrUndefined(a[0].kbaId)&&(o.id=a[0].kbaId)}return a.forEach(function(t){var e=[],r=[];n.isArray(t.outputParts)&&(e=t.outputParts),e.filter(function(t){return"answer"===t.type}).forEach(function(t){if("answer"===t.type){var e="";e=i(t.text),e=e.replace(/&lt;(\/?u)&gt;/g,"<$1>"),e=p(e,t,o),r.push({answer:e,additions:t.metadata,images:t.images,videos:t.videos})}});var s=e.filter(function(t){return"relatedFAQs"===t.type});s.length>0&&(s=s.reduce(function(t,e){return t.faQs.concat(e.faQs)},{faQs:[]})),o.answers.push(r),o.faqs.push(s)}),o.answers.length>0&&n.isArray(o.answers[0])&&o.answers[0].length>0&&(o.answer=o.answers[0][0].answer,o.additions=o.answers[0][0].additions,o.images=o.answers[0][0].images,o.videos=o.answers[0][0].videos),o.faqs.length>0&&n.isArray(o.faqs[0])&&(o.faqs=o.faqs[0]),o}function p(e,r,n){return e=d(e,n.dialogPath),e=t(e,r.links,n.interactionId)}function d(t,e){var r=/%\{DialogOption\((.*?)\)\}/g;return t.replace(r,function(t,r){var n=s.template(c);return n({path:e,text:r})})}function f(t){var e={data:{}};return n.isNumber(t.minFaqs)&&(e.data.minFaqs=t.minFaqs),n.isNumber(t.maxFaqs)&&(e.data.maxFaqs=t.maxFaqs),n.isNumber(t.classificationId)&&(e.data.classificationId=t.classificationId),n.isNumber(t.categoryId)&&(e.data.categoryId=t.categoryId),n.isObject(t.project)&&(e.project=t.project),n.isObject(t.context)&&(e.context=t.context),n.isObject(t.queryParams)&&(e.queryParams=t.queryParams),n.isBoolean(t.useXMLHttpRequest)&&(e.useXMLHttpRequest=t.useXMLHttpRequest),n.isObject(t.requestOptions)&&(e.requestOptions=t.requestOptions),e}function h(t){n.isString(t.dialogOptionTemplate)&&(c=t.dialogOptionTemplate)}function g(t){if(t=t||{},n.isNullOrUndefined(t.question)||n.isEmptyString(t.question))throw new Error("Missing property question in first parameter");h(t);var e=f(t);return e.data.q=n.removeXss(t.question),n.isString(t.dialogPath)&&(n.isObject(e.context)||(e.context={}),n.isObject(e.context.session)||(e.context.session={}),e.context.session.dialogPath=t.dialogPath),a("ask",e).then(function(n){var i=r(n,"question",e);return i.question=t.question,i})}function m(t){if(t=t||{},n.isNullOrUndefined(t.id)||n.isEmptyString(t.id))throw new Error("Missing property id in first parameter");n.isNullOrUndefined(t.interactionId)||(n.isObject(t.context)||(t.context={}),n.isObject(t.context.interaction)||(t.context.interaction={}),t.context.interaction.originId=t.interactionId),h(t),t.id=parseInt(t.id,10);var e=f(t);return a("faqs/"+t.id+"/output",e).then(function(t){return r(t,"faq",e)})}function y(t){if(t=t||{},n.isNullOrUndefined(t.event)||n.isEmptyString(t.event))throw new Error("Missing property event in first parameter");h(t),t.event=n.removeXss(t.event);var e=f(t);return a("event/"+t.event,e).then(function(t){return r(t,"event",e)})}function b(){l.tDialogState=null,j.remove("tDialogState")}function v(t){if(t=t||{},n.isNullOrUndefined(t.path)||n.isEmptyString(t.path))throw new Error("Missing property path in first parameter");h(t);var e=f(t);return e.data.path=t.path,a("dialogstep",e).then(function(t){return r(t,"dialogstep",e)})}function w(t){if(t=t||{},n.isNullOrUndefined(t.interactionId)||n.isEmptyString(t.interactionId))throw new Error("Missing property interactionId in first parameter");if(n.isNullOrUndefined(t.score)||n.isEmptyString(t.score))throw new Error("Missing property score in first parameter");if(n.isNullOrUndefined(t.label)||n.isEmptyString(t.label))throw new Error("Missing property label in first parameter");if(t.score=parseInt(t.score,10),isNaN(t.score)||t.score>5||t.score<-5)throw new Error("Score must be an integer from -5 to 5");t.label=n.removeXss(t.label);var e={data:{originInteractionId:t.interactionId,label:t.label,score:t.score}};return t.comment&&(e.data.comment=n.removeXss(t.comment)),n.isObject(t.queryParams)&&(e.queryParams=t.queryParams),n.isBoolean(t.useXMLHttpRequest)&&(e.useXMLHttpRequest=t.useXMLHttpRequest),n.isObject(t.requestOptions)&&(e.requestOptions=t.requestOptions),a("feedback",e)}function x(t){if(t=t||{},n.isNullOrUndefined(t.interactionId)||n.isEmptyString(t.interactionId))throw new Error("Missing property interactionId in first parameter");if(n.isNullOrUndefined(t.url)||n.isEmptyString(t.url))throw new Error("Missing property url in first parameter");if(n.isNullOrUndefined(t.urlId)||n.isEmptyString(t.urlId))throw new Error("Missing property urlId in first parameter");t.url=n.removeXss(t.url),t.urlId=parseInt(t.urlId,10);var e={data:{originInteractionId:t.interactionId,url:t.url,urlId:t.urlId}};return n.isObject(t.queryParams)&&(e.queryParams=t.queryParams),n.isBoolean(t.useXMLHttpRequest)&&(e.useXMLHttpRequest=t.useXMLHttpRequest),n.isObject(t.requestOptions)&&(e.requestOptions=t.requestOptions),a("linkclick",e)}function k(t){t=t||{},t.classificationId=parseInt(t.classificationId,10);var e={data:{includeFaqs:!1}};return n.isObject(t.queryParams)&&(e.queryParams=t.queryParams),n.isBoolean(t.useXMLHttpRequest)&&(e.useXMLHttpRequest=t.useXMLHttpRequest),n.isObject(t.requestOptions)&&(e.requestOptions=t.requestOptions),n.isBoolean(t.includeFaqs)&&(e.data.includeFaqs=t.includeFaqs),a("classifications/"+t.classificationId+"/categories",e)}function q(t){t=t||{},t.classificationId=parseInt(t.classificationId,10),t.categoryId=parseInt(t.categoryId,10);var e={data:{}};return n.isObject(t.queryParams)&&(e.queryParams=t.queryParams),n.isBoolean(t.useXMLHttpRequest)&&(e.useXMLHttpRequest=t.useXMLHttpRequest),n.isObject(t.requestOptions)&&(e.requestOptions=t.requestOptions),n.isNumber(t.max)&&(e.data.max=t.max),a("classifications/"+t.classificationId+"/categories/"+t.categoryId+"/faqs",e)}function S(t){t=t||{},t.classificationId=parseInt(t.classificationId,10);var e={data:{}};return e.data=n.extend(e.data,t),n.isObject(t.queryParams)&&(e.queryParams=t.queryParams),n.isBoolean(t.useXMLHttpRequest)&&(e.useXMLHttpRequest=t.useXMLHttpRequest),n.isObject(t.requestOptions)&&(e.requestOptions=t.requestOptions),n.isNumber(t.max)&&(e.data.max=t.max),a("faqs",e).then(function(t){return t.result=t.result.matches.concat(t.result.related),t})}var j=u();return i.setOptions({renderer:new i.Renderer,gfm:!1,tables:!1,sanitize:!0,smartLists:!0}),{ask:g,askFaq:m,searchFaqs:S,linkClick:x,sendEvent:y,dialogStep:v,tDialogStepOut:b,sendFeedback:w,getCategories:k,getFaqsByCategoryId:q}}()},{"../templates/dialog-option.html":23,"../templates/va-link.html":26,"../utils.js":29,"./globalStorage.js":12,"./link.js":14,"./request.js":15,"./session.js":16,dot:4,marked:5}],10:[function(t,e,r){"use strict";var n=[],i=t("../utils.js"),s=t("./link.js"),o=t("dot"),a=t("./engine.js"),u=t("../templates/faqbox.html"),l=t("./hooks.js"),c=t("./storage.js");e.exports=function(t,e,r){function p(t,e){S.addHistory(t);var r=E("answerLoaded",t).then(function(){var r=null;return i.isNullOrUndefined(t.answer)?_("interactionEnd",t):(i.isNullOrUndefined(t.question)&&!i.isNullOrUndefined(t.originalResult.outputs[0].faqQuestion)&&(t.question=t.originalResult.outputs[0].faqQuestion),i.isElement(e)?r=e:i.isElement(A.output)&&(r=A.output),i.isElement(r)?d(t,r):_("interactionEnd",t))});return r["catch"](y),r}function d(t,e){var r=E("showOutput",t,e).then(function(){return i.isElement(e)&&(e.innerHTML=t.answer,e.removeEventListener("click",f),e.addEventListener("click",f)),_("interactionEnd",t,e)});return r["catch"](y),r}function f(t){var e=t.currentTarget;if(i.checkEventPropagation(e,t.target,"[data-dcx-dialog-option]")){var r=t.target.getAttribute("data-dcx-dialog-option"),n=t.target.getAttribute("data-dcx-dialogpath"),s={};return s.question=r,i.isEmptyString(n)||(s.dialogPath=n),a.ask(s).then(function(t){return p(t,e)})}}function h(t){var r=E("getAnswer",t).then(function(){if(i.isNullOrUndefined(t.id)||i.isEmptyString(t.id))throw new Error("Missing id property in first parameter.");return!i.isNumber(t.minFaqs)&&i.isNumber(T.minFaqs)&&(t.minFaqs=T.minFaqs),!i.isNumber(t.maxFaqs)&&i.isNumber(T.maxFaqs)&&(t.maxFaqs=T.maxFaqs),!i.isNumber(t.classificationId)&&i.isNumber(T.classificationId)&&(t.classificationId=T.classificationId),!i.isString(t.dialogOptionTemplate)&&i.isString(T.dialogOptionTemplate)&&(t.dialogOptionTemplate=T.dialogOptionTemplate),!i.isNumber(t.categoryId)&&i.isNumber(T.categoryId)&&(t.categoryId=T.categoryId),i.isNullOrUndefined(t.interactionId)&&!i.isNullOrUndefined(L)&&(t.interactionId=L),t.project=i.extend({},T.project,t.project),t.context=i.extend({},T.context,t.context),a.askFaq(t)});return r["catch"](y),r.then(function(r){var n=e.querySelector("[data-dcx-faq-"+t.id+"-output]");return p(r,n)})}function g(t){i.isNullOrUndefined(t.interactionId)||i.isEmptyString(t.interactionId)||(L=t.interactionId)}function m(){L=null}function y(t){_("error",t)}function b(t){t=t||{};var e=E("getFaqsByCategoryId",t).then(function(){if(t.classificationId=t.classificationId||T.classificationId,i.isNullOrUndefined(t.classificationId))throw new Error("Faqbox - missing classificationId");if(i.isNullOrUndefined(t.categoryId))throw new Error("Faqbox - missing categoryId");return T.categoryId=t.categoryId,!i.isNumber(t.max)&&i.isNumber(T.max)&&(t.max=T.max),a.getFaqsByCategoryId(t)});return e["catch"](y),e.then(function(t){return v(t)})}function v(t,r){var n=t.result||t.faqs;i.isArray(n)||(n=[]);var s=E("showFaqs",t).then(function(){var t=o.template(T.template);A.list.innerHTML=t(n),n.forEach(function(t){i.isNumber(r)&&(t.categoryId=r);var n=e.querySelector('[data-dcx-faq="'+t.id+'"]');i.isElement(n)&&n.addEventListener("click",function(){h(t)})})}).then(function(){return _("interactionEnd",t),t});return s}function w(t){t=t||{};var e=E("searchFaqs",t).then(function(){if(t.classificationId=t.classificationId||T.classificationId,i.isNullOrUndefined(t.classificationId))throw new Error("Faqbox - missing classificationId");if(i.isNullOrUndefined(t.searchText))throw new Error("Faqbox - missing searchText");return!i.isNumber(t.max)&&i.isNumber(T.max)&&(t.max=T.max),a.searchFaqs(t)});return e["catch"](y),e.then(function(t){return v(t)})}function x(t){t.addEventListener("click",function(e){i.checkEventPropagation(t,e.target,"[data-dcx-link]")&&s.click(e.target)})}function k(t){A.list=t.querySelector("[data-dcx-faqlist-list]"),A.output=t.querySelector("[data-dcx-faqlist-output]")}function q(){var e=n.indexOf(t);e>-1&&n.splice(e,1)}if(!i.isString(t))throw new Error("First argument expected to be a String");if(t="faqbox__"+t,n.indexOf(t)>-1)throw new Error('faqbox with id: "'+t+'" already exists');if(i.isString(e)&&(e=document.querySelector(e)),!i.isElement(e))throw new Error("Missing rootElement!");var S=c(t),j=l({preGetAnswer:function(){},preShowOutput:function(){},preAnswerLoaded:function(){},interactionEnd:function(){},preShowFaqs:function(){},preSearchFaqs:function(){},preGetFaqsByCategoryId:function(){}}),E=j.before,O=j.off,I=j.on,_=j.trigger,N={template:u},T=i.extend(N,r),A={output:null,list:null},L=void 0;return function(){k(e),x(e),n.push(t)}(),{id:t,element:e,on:i.wrap(I),off:i.wrap(O),getAnswer:i.wrap(h),dialogStep:i.wrap(a.dialogStep),search:i.wrap(w),sendSystemEvent:i.wrap(a.sendEvent),setFaqs:i.wrap(v),getFaqsByCategoryId:i.wrap(b),setInteraction:i.wrap(g),clearInteraction:i.wrap(m),storage:{store:i.wrap(S.store),remove:i.wrap(S.remove)},history:{get:i.wrap(S.getHistory),filter:i.wrap(S.filterHistory),last:i.wrap(S.lastHistory),clear:i.wrap(S.clearHistory),remove:i.wrap(S.removeHistory)},destroy:i.wrap(q)}}},{"../templates/faqbox.html":24,"../utils.js":29,"./engine.js":9,"./hooks.js":13,"./link.js":14,"./storage.js":19,dot:4}],11:[function(t,e,r){"use strict";var n=[],i=t("../utils.js"),s=t("./engine.js"),o=t("./hooks.js");e.exports=function(t,e){function r(){var t=e.querySelectorAll("[data-dcx-feedbackbox-option][data-selected]");t=Array.prototype.slice.call(t),t.forEach(function(t){t.removeAttribute("data-selected"),"INPUT"==t.tagName&&(t.checked=!1)})}function a(){i.isElement(S.comment)&&("TEXTAREA"!=S.comment.tagName&&"INPUT"!=S.comment.tagName||(S.comment.value="")),r()}function u(t){var e=d(t);e.interactionId=j,r(),t.setAttribute("data-selected",""),v("optionClick",e).then(function(){return s.sendFeedback(e)}).then(function(t){return w("optionClick",e)})}function l(t){return i.isNullOrUndefined(t)||!i.isNullOrUndefined(t.interactionId)||i.isNullOrUndefined(j)||(t.interactionId=j),v("submit",t).then(function(){return s.sendFeedback(t)}).then(function(t){return q("interactionEnd",t)}).then(p)}function c(t){i.isNullOrUndefined(t.interactionId)||i.isEmptyString(t.interactionId)||(j=t.interactionId)}function p(){j=null}function d(t){var e={};if(i.isElement(t)){var r=parseInt(t.getAttribute("data-score"),10);isNaN(r)||(e.score=r);var n=t.getAttribute("data-label");i.isNullOrUndefined(n)||(e.label=n)}return e}function f(){var t=Array.prototype.slice.call(S.options),e=t.filter(function(t){return t.hasAttribute("data-selected")})[0],r={};return i.isElement(S.comment)&&(r.comment=i.removeXss(S.comment.value)),i.extend(r,d(e))}function h(t){if(i.isNullOrUndefined(t.score)||isNaN(t.score))throw new Error("Feedback - Score is not provided or not a number");if(i.isNullOrUndefined(t.label))throw new Error("Feedback - Label is not provided");return l(t)}function g(t){i.isElement(S.submit)&&S.submit.addEventListener("click",function(){var t=f();l(t)}),t.addEventListener("click",function(t){t.target.hasAttribute("data-dcx-feedbackbox-option")&&u(t.target)})}function m(t){S.submit=t.querySelector("[data-dcx-feedbackbox-submit]"),S.options=t.querySelectorAll("[data-dcx-feedbackbox-option]"),S.comment=t.querySelector("[data-dcx-feedbackbox-comment]")}function y(){var e=n.indexOf(t);e>-1&&n.splice(e,1)}if(!i.isString(t))throw new Error("First argument expected to be a String");if(t="feedbackbox__"+t,n.indexOf(t)>-1)throw new Error('feedbackbox with id: "'+t+'" already exists');if(i.isString(e)&&(e=document.querySelector(e)),!i.isElement(e))throw new Error("Missing rootElement!");var b=o({preOptionClick:function(){},postOptionClick:function(){},preSubmit:function(){},interactionEnd:function(){}}),v=b.before,w=b.after,x=b.off,k=b.on,q=b.trigger,S={submit:null,options:[],comment:null},j=void 0;return function(){m(e),g(e),n.push(t)}(),{id:t,element:e,on:i.wrap(k),off:i.wrap(x),sendFeedback:i.wrap(h),reset:i.wrap(a),setInteraction:i.wrap(c),destroy:i.wrap(y)}}},{"../utils.js":29,"./engine.js":9,"./hooks.js":13}],12:[function(t,e,r){"use strict";var n=t("./storage.js"),i=void 0;e.exports=function(){return i=i||n("dcx")}},{"./storage.js":19}],13:[function(t,e,r){"use strict";var n=t("../utils.js"),i=t("promise-polyfill");e.exports=function(t){function e(t,e){return function(){var r=Array.prototype.slice.call(arguments);return e.apply(t,r)}}function r(){var r=this;if(n.isObject(arguments[0])){var i=arguments[0];for(var s in i)t[s]=e(r,i[s])}else n.isString(arguments[0])&&n.isFunction(arguments[1])&&(t[arguments[0]]=e(r,arguments[1]))}function s(e){n.isNullOrUndefined(t[e])||(t[e]=function(){})}function o(t){n.isArray(t)?t.forEach(s):n.isString(t)&&s(t)}function a(t,e){return n.isNullOrUndefined(t)?e:t+e.charAt(0).toUpperCase()+e.slice(1)}function u(e,r,s){r=a(e,r);var o=s;return n.isFunction(t[r])&&(o=t[r].apply(this,s)),i.resolve(o)}function l(t){return u("pre",t,Array.prototype.slice.call(arguments,1))}function c(t){return u("post",t,Array.prototype.slice.call(arguments,1))}function p(t){return u(null,t,Array.prototype.slice.call(arguments,1))}if(t=t||{},!n.isObject(t)||n.isArray(t))throw new Error("expecting an object as first parameter");return{on:r,off:o,after:c,before:l,trigger:p}}},{"../utils.js":29,"promise-polyfill":6}],14:[function(t,e,r){"use strict";var n=t("../utils.js"),i=t("./engine.js");e.exports=function(){function t(t){if(n.isElement(t)){var e={urlId:t.getAttribute("data-id")||"",url:t.getAttribute("data-url")||"",interactionId:t.getAttribute("data-interactionid")||""};if(!n.isNullOrUndefined(e.urlId)&&!n.isEmptyString(e.urlId)&&!(n.isNullOrUndefined(e.url)||n.isEmptyString(e.url)||n.isNullOrUndefined(e.interactionId)||n.isEmptyString(e.interactionId)))return i.linkClick(e)}}return{click:t}}()},{"../utils.js":29,"./engine.js":9}],15:[function(t,e,r){"use strict";var n=t("./settings.js"),i=t("../utils.js"),s=t("../../lib/vendor/jsonp.js"),o=t("promise-polyfill");t("whatwg-fetch");var a=t("./sessionstarted.js"),u=t("./session.js"),l=t("./globalStorage.js");e.exports=function(){function t(t,e){t=t.replace(/^[\/|\\]+/,"");var r={project:{},context:{interaction:{},session:{},user:{}}};i.extend(r.context,n.context||{}),e=i.extend({},r,e||{});var s={culture:e.project.culture||n.project.culture,apiKey:e.project.apiKey||n.project.apiKey};i.isNullOrUndefined(u.mode)||(s["session.mode"]=u.mode);for(var o in e.context)for(var l in e.context[o])s[o+"."+l]=e.context[o][l];for(var c in e.queryParams)s[c]=e.queryParams[c];i.extend(s,e.data);var p=e.project.customerKey||n.project.customerKey,d=e.project.key||n.project.key;if(i.isNullOrUndefined(s.apiKey)||i.isEmptyString(s.apiKey))throw new Error("Missing apiKey.");if(i.isNullOrUndefined(s.culture)||i.isEmptyString(s.culture))throw new Error("Missing culture.");if(i.isNullOrUndefined(p)||i.isEmptyString(p))throw new Error("Missing customer key.");if(i.isNullOrUndefined(d)||i.isEmptyString(d))throw new Error("Missing project key.");var h=n.engineUrl||"https://"+p+"-"+d+".digitalcx.com",g=h+"/"+t;return a===!1?a=f(g,s,e):a["catch"](function(){a=!1}).then(function(){return f(g,s,e)})}function e(t,e){return new o(function(r,i){var o=setTimeout(function(){i({errorType:"timeout",data:e})},n.timeout||2e4);s(t,e,function(t){clearTimeout(o),r(t)})})}function r(t){return t.json()}function c(t){if(t.status>=200&&t.status<300)return t;var e=new Error(t.statusText);throw e.response=t,e}function p(t){var e=[];for(var r in t)t.hasOwnProperty(r)&&e.push(encodeURIComponent(r)+"="+encodeURIComponent(t[r]));return e.join("&")}function d(t,e,s){var o={Accept:"application/json","Content-Type":"application/json"},a=s.requestOptions||n.requestOptions;a&&a.headers&&(o=i.extend(o,a.headers)),i.isObject(e)&&(t=t+"?"+p(e));var u={method:"GET",headers:o};return fetch(t,u).then(c).then(r)}function f(t,r,s){r["session.id"]=u.id||"",u.tDialogState&&/\/ask$/.test(t)&&(r.tDialogState=u.tDialogState);var o=e;return(s.useXMLHttpRequest||i.isNullOrUndefined(s.useXMLHttpRequest)&&n.useXMLHttpRequest)&&(o=d),o(t,r,s).then(h)}function h(t){return i.isObject(t)&&t.sessionId&&(u.id=t.sessionId,g.store("sessionId",u.id)),i.isObject(t)&&i.isObject(t.result)&&t.result.tDialogState?(u.tDialogState=t.result.tDialogState,g.store("tDialogState",u.tDialogState)):(u.tDialogState=null,g.remove("tDialogState")),t}var g=l();return i.isNullOrUndefined(g.store("sessionId"))||(u.id=g.store("sessionId")),i.isNullOrUndefined(g.store("tDialogState"))||(u.tDialogState=g.store("tDialogState")),t}()},{"../../lib/vendor/jsonp.js":2,"../utils.js":29,"./globalStorage.js":12,"./session.js":16,"./sessionstarted.js":17,"./settings.js":18,"promise-polyfill":6,"whatwg-fetch":7}],16:[function(t,e,r){"use strict";e.exports={id:""}},{}],17:[function(t,e,r){"use strict";var n=t("promise-polyfill"),i=t("./session.js"),s=t("../utils.js");e.exports=function(){return!s.isEmptyString(i.id)&&n.resolve()}()},{"../utils.js":29,"./session.js":16,"promise-polyfill":6}],18:[function(t,e,r){"use strict";e.exports={context:{interaction:{},session:{},user:{},dim:{}},project:{apiKey:"",culture:"",customerKey:"",key:""},storage:{storageType:"",expirationTime:12e5},useXMLHttpRequest:!1,requestOptions:{headers:{}},queryParams:{},timeout:2e4}},{}],19:[function(t,e,r){"use strict";var n=t("../utils.js"),i=t("amplify-store"),s=t("./settings.js");e.exports=function(t){function e(){g=f(t,g,{expires:s.storage.expirationTime})}function r(t){g.history.push(t),e()}function o(t){return n.isNullOrUndefined(t)?g.storage:(n.isNullOrUndefined(arguments[1])||(g.storage[t]=arguments[1],e()),n.isNullOrUndefined(g.storage[t]),g.storage[t])}function a(){var t=arguments[0];return n.isNumber(t)?g.history.slice(t,t===-1?g.history.length:++t)[0]:g.history.slice(0)}function u(t){var r=1;return n.isNumber(arguments[1])&&(r=arguments[1]),n.isNumber(t)?g.history.splice(t,r):g.history=[],e(),g.history.slice(0)}function l(t){if(!n.isFunction(t))throw new Error(t+" is not a function");return g.history.filter(t)}function c(){u()}function p(){return a(-1)}function d(t){if(n.isNullOrUndefined(t))throw new Error(t+" is not defined");delete g.storage[t],e()}if(!n.isString(t))throw new Error("expecting a string as first parameter");var f=i;if(n.isObject(s.storage)&&!n.isNullOrUndefined(s.storage.storageType)){var h=s.storage.storageType;n.isNullOrUndefined(i[h])||i.types[h]&&(f=i[h])}var g=f(t)||f(t,{});return g.storage=g.storage||{},g.history=g.history||[],{store:o,remove:d,addHistory:r,getHistory:a,removeHistory:u,filterHistory:l,lastHistory:p,clearHistory:c}}},{"../utils.js":29,"./settings.js":18,"amplify-store":3}],20:[function(t,e,r){"use strict";var n=[],i=t("../utils.js"),s=t("./link.js"),o=t("./storage.js"),a=t("./engine.js"),u=t("./hooks.js"),l=(t("promise-polyfill"),t("dot")),c=t("../templates/quick-reply.html");e.exports=function(t,e,r){function p(t){i.isString(t.quickReplyTemplate)&&(c=t.quickReplyTemplate)}function d(t){E.addHistory(t);var e=I("answerLoaded",t).then(function(){return i.isNullOrUndefined(t.answer)?(T("interactionEnd",t),t):f(t)});return e["catch"](v),e}function f(t){var e=I("showOutput",t).then(function(){return i.isElement(U.output)&&(U.output.innerHTML=t.answer),i.isElement(U.quickReplies)&&"TDialog"===t.outputType&&Array.isArray(t.quickReplies)?h(t):(T("interactionEnd",t),t)});return e["catch"](v),e}function h(t){var e=I("renderQuickReplies",t).then(function(){return U.quickReplies.innerHTML=t.quickReplies.reduce(function(t,e){var r=l.template(c);return""+t+r(e)},""),T("interactionEnd",t),t});return e["catch"](v),e}function g(){i.isElement(U.quickReplies)&&(U.quickReplies.innerHTML="")}function m(){i.isElement(U.output)&&(U.output.innerHTML="")}function y(){i.isElement(U.inputQuestion)&&(U.inputQuestion.value="")}function b(t){i.isNullOrUndefined(t)||i.isNullOrUndefined(t.question)||i.isEmptyString(t.question)||(t.question=i.removeXss(t.question));var e=I("ask",t).then(function(){if(i.isNullOrUndefined(t.question)||i.isEmptyString(t.question))throw new Error("Missing question property in first parameter.");return!i.isNumber(t.minFaqs)&&i.isNumber(L.minFaqs)&&(t.minFaqs=L.minFaqs),!i.isNumber(t.maxFaqs)&&i.isNumber(L.maxFaqs)&&(t.maxFaqs=L.maxFaqs),!i.isNumber(t.classificationId)&&i.isNumber(L.classificationId)&&(t.classificationId=L.classificationId),!i.isString(t.dialogOptionTemplate)&&i.isString(L.dialogOptionTemplate)&&(t.dialogOptionTemplate=L.dialogOptionTemplate),!i.isString(t.quickReplyTemplate)&&i.isString(L.quickReplyTemplate)&&(t.quickReplyTemplate=L.quickReplyTemplate,p(t)),t.project=i.extend({},L.project,t.project),t.context=i.extend({},L.context,t.context),a.ask(t)});return e["catch"](v),e.then(d)}function v(t){T("error",t)}function w(t){var e=I("sendEvent",t).then(function(){if(i.isNullOrUndefined(t.event)||i.isEmptyString(t.event))throw new Error("Missing event property in first parameter.");return!i.isNumber(t.minFaqs)&&i.isNumber(L.minFaqs)&&(t.minFaqs=L.minFaqs),!i.isNumber(t.maxFaqs)&&i.isNumber(L.maxFaqs)&&(t.maxFaqs=L.maxFaqs),!i.isNumber(t.classificationId)&&i.isNumber(L.classificationId)&&(t.classificationId=L.classificationId),!i.isString(t.dialogOptionTemplate)&&i.isString(L.dialogOptionTemplate)&&(t.dialogOptionTemplate=L.dialogOptionTemplate),!i.isString(t.quickReplyTemplate)&&i.isString(L.quickReplyTemplate)&&(t.quickReplyTemplate=L.quickReplyTemplate,p(t)),t.project=i.extend({},L.project,t.project),t.context=i.extend({},L.context,t.context),a.sendEvent(t)});return e["catch"](v),e.then(d)}function x(t,e){var r={};return r.question=t,i.isEmptyString(e)||(r.dialogPath=e),b(r)}function k(t){return b({question:t})}function q(t){i.isElement(U.inputSubmit)&&U.inputSubmit.addEventListener("click",function(){i.isElement(U.inputQuestion)&&b({question:U.inputQuestion.value})}),t.addEventListener("click",function(e){if(i.checkEventPropagation(t,e.target,"[data-dcx-dialog-option]")){var r=e.target.getAttribute("data-dcx-dialog-option"),n=e.target.getAttribute("data-dcx-dialogpath");x(r,n)}if(i.checkEventPropagation(t,e.target,"[data-dcx-quick-reply]")){var o=e.target.getAttribute("data-dcx-quick-reply");k(o)}else i.checkEventPropagation(t,e.target,"[data-dcx-link]")&&s.click(e.target)})}function S(t){
U.output=t.querySelector("[data-dcx-output-answer]"),U.inputQuestion=t.querySelector("[data-dcx-input-question]"),U.inputSubmit=t.querySelector("[data-dcx-input-submit]"),U.quickReplies=t.querySelector("[data-dcx-quick-replies]")}function j(){var e=n.indexOf(t);e>-1&&n.splice(e,1)}if(!i.isString(t))throw new Error("First argument expected to be a String");if(t="va__"+t,n.indexOf(t)>-1)throw new Error('va with id: "'+t+'" already exists');if(i.isString(e)&&(e=document.querySelector(e)),!i.isElement(e))throw new Error("Missing rootElement!");var E=o(t),O=u({preAsk:function(){},preDialogStep:function(){},preSendEvent:function(){},preShowOutput:function(){},preRenderQuickReplies:function(){},preAnswerLoaded:function(){},error:function(){},interactionEnd:function(){}}),I=O.before,_=O.off,N=O.on,T=O.trigger,A={minFaqs:null,maxFaqs:null},L=i.extend(A,r),U={output:null,inputQuestion:null,inputSubmit:null};return function(){S(e),q(e),n.push(t)}(),{id:t,element:e,on:i.wrap(N),off:i.wrap(_),ask:i.wrap(b),dialogOptionClick:i.wrap(x),dialogStep:i.wrap(a.dialogStep),tDialogStepOut:i.wrap(a.tDialogStepOut),sendEvent:i.wrap(w),sendSystemEvent:i.wrap(a.sendEvent),setOutput:i.wrap(d),clearOutput:i.wrap(m),clearInput:i.wrap(y),clearQuickReplies:i.wrap(g),storage:{store:i.wrap(E.store),remove:i.wrap(E.remove)},history:{get:i.wrap(E.getHistory),filter:i.wrap(E.filterHistory),last:i.wrap(E.lastHistory),clear:i.wrap(E.clearHistory),remove:i.wrap(E.removeHistory)},destroy:i.wrap(j)}}},{"../templates/quick-reply.html":25,"../utils.js":29,"./engine.js":9,"./hooks.js":13,"./link.js":14,"./storage.js":19,dot:4,"promise-polyfill":6}],21:[function(t,e,r){"use strict";var n=t("./app/settings.js"),i=t("dot"),s=t("marked"),o=t("./utils-external.js"),a=t("./utils-internal.js"),u=t("./app/globalStorage.js"),l=void 0;t("../lib/polyfill/find.js"),e.exports=function(e){e=e||{},n=o.extend(n,e);var r=u(),c=t("./app/virtualassistant.js"),p=t("./app/faqlist.js"),d=t("./app/categorylist.js"),f=t("./app/feedbackbox.js");return l=l||{settings:n,VirtualAssistant:c,FaqList:p,FeedbackBox:f,CategoryList:d,utils:o,dot:i,marked:s,plugins:{},storage:{store:a.wrap(r.store),remove:a.wrap(r.remove)}}}},{"../lib/polyfill/find.js":1,"./app/categorylist.js":8,"./app/faqlist.js":10,"./app/feedbackbox.js":11,"./app/globalStorage.js":12,"./app/settings.js":18,"./app/virtualassistant.js":20,"./utils-external.js":27,"./utils-internal.js":28,dot:4,marked:5}],22:[function(t,e,r){e.exports='<ul>\r\n{{~it:category}}\r\n\t<li>\r\n\t\t<a href="javascript: void(0);" data-dcx-category="{{=category.id}}">{{=category.name}}</a>\r\n\t\t<ul>\r\n\t\t{{~category.subCategories:subcategory}}\r\n\t\t\t<li>\r\n\t\t\t\t<a href="javascript: void(0);" data-dcx-category="{{=subcategory.id}}">{{=subcategory.name}}</a>\r\n\t\t\t</li>\r\n\t\t{{~}}\r\n\t\t</ul>\r\n\t</li>\r\n{{~}}\r\n</ul>\r\n'},{}],23:[function(t,e,r){e.exports='<a href="javascript:void(0);" data-dcx-dialog-option="{{=it.text}}" data-dcx-dialogpath="{{=it.path}}">{{=it.text}}</a>\r\n'},{}],24:[function(t,e,r){e.exports='<ul>\r\n{{~it:faq}}\r\n\t<li>\r\n\t\t<a href="javascript: void(0);" data-dcx-faq="{{=faq.id}}">{{=faq.question}}</a>\r\n\t\t<p data-dcx-faq-{{=faq.id}}-output></p>\r\n\t</li>\r\n{{~}}\r\n</ul>\r\n'},{}],25:[function(t,e,r){e.exports='<a href="javascript:void(0);" data-dcx-quick-reply="{{=it.text}}">{{=it.text}}</a>\r\n'},{}],26:[function(t,e,r){e.exports='<a href="{{=it.url}}" target="{{=it.target}}" data-url="{{=it.url}}" data-id="{{=it.id}}" data-interactionid="{{=it.interactionId}}" data-dcx-link>{{=it.text}}</a>\r\n'},{}],27:[function(t,e,r){"use strict";var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e.exports=function(){var t={};return t.extend=function e(t){t=t||{};for(var r=1;r<arguments.length;r++){var i=arguments[r];if(i)for(var s in i)i.hasOwnProperty(s)&&("object"===n(i[s])?t[s]=e(t[s],i[s]):t[s]=i[s])}return t},["Arguments","Function","String","Number","Date","RegExp","Error"].forEach(function(e){t["is"+e]=function(t){return Object.prototype.toString.call(t)==="[object "+e+"]"}}),t.isArray=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)},t.isBoolean=function(t){return t===!0||t===!1||"[object Boolean]"===toString.call(t)},t.isObject=function(t){var e="undefined"==typeof t?"undefined":n(t);return"function"===e||"object"===e&&!!t},t.isElement=function(t){return!(!t||1!==t.nodeType)},t.isNull=function(t){return null===t},t.isUndefined=function(t){return void 0===t},t.isNullOrUndefined=function(e){return t.isNull(e)||t.isUndefined(e)},t.isEmptyString=function(t){return""===t},t.removeXss=function(t){return t=t||"",t.replace(/<.+?\/?>/g,"")},t}()},{}],28:[function(t,e,r){"use strict";e.exports=function(){var t={};return t.wrap=function(t){return function(){var e=Array.prototype.slice.call(arguments);return t.apply(this,e)}},t.checkEventPropagation=function(t,e,r){var n=t.querySelectorAll(r);n=Array.prototype.slice.call(n);var i=n.find(function(t){if(t===e)return!0;var r=t.querySelectorAll("*");return r=Array.prototype.slice.call(r),r.find(function(t){return t===e})});return void 0!==i},t}()},{}],29:[function(t,e,r){"use strict";var n=t("./utils-external.js"),i=t("./utils-internal.js");e.exports=n.extend({},n,i)},{"./utils-external.js":27,"./utils-internal.js":28}]},{},[21])(21)});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)
},{"timers":10}],5:[function(require,module,exports){
/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

},{}],6:[function(require,module,exports){
(function (process){
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */
// eslint-disable-next-line complexity

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
    return true;
  } // Internet Explorer and Edge do not support colors.


  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  } // Is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */


function formatArgs(args) {
  args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

  if (!this.useColors) {
    return;
  }

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into

  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if (match === '%%') {
      return;
    }

    index++;

    if (match === '%c') {
      // We only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });
  args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */


function log() {
  var _console;

  // This hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */


function save(namespaces) {
  try {
    if (namespaces) {
      exports.storage.setItem('debug', namespaces);
    } else {
      exports.storage.removeItem('debug');
    }
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */


function load() {
  var r;

  try {
    r = exports.storage.getItem('debug');
  } catch (error) {} // Swallow
  // XXX (@Qix-) should we be logging these?
  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */


function localstorage() {
  try {
    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
    // The Browser also has localStorage in the global context.
    return localStorage;
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}

module.exports = require('./common')(exports);
var formatters = module.exports.formatters;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (error) {
    return '[UnexpectedJSONParseError]: ' + error.message;
  }
};


}).call(this,require('_process'))
},{"./common":7,"_process":8}],7:[function(require,module,exports){
"use strict";

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */
function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = require('ms');
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * Active `debug` instances.
  */

  createDebug.instances = [];
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      // Disabled?
      if (!debug.enabled) {
        return;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return match;
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    debug.extend = extend; // Debug.formatArgs = formatArgs;
    // debug.rawLog = rawLog;
    // env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);
    return debug;
  }

  function destroy() {
    var index = createDebug.instances.indexOf(this);

    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    }

    return false;
  }

  function extend(namespace, delimiter) {
    return createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */


  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }
  /**
  * Disable debug output.
  *
  * @api public
  */


  function disable() {
    createDebug.enable('');
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */


  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */


  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

module.exports = setup;


},{"ms":5}],8:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],9:[function(require,module,exports){
(function (setImmediate){
(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}
  
  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function() {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new (this.constructor)(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    return new Promise(function (resolve, reject) {
      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
      var args = Array.prototype.slice.call(arr);
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
    function (fn) {
      setTimeoutFunc(fn, 0);
    };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };
  
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }

})(this);

}).call(this,require("timers").setImmediate)
},{"timers":10}],10:[function(require,module,exports){
(function (setImmediate,clearImmediate){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":8,"timers":10}],11:[function(require,module,exports){
'use strict';

var initFeedbackBox = require('./index.js');

module.exports = function (dcx, element, id, component) {

    var feedbackBox = initFeedbackBox(dcx, element, id, component);
    var $scrollableContainer = component.element.querySelector('.cxco-scrollable');
    /**
     * states:
     * 0 dropdown closed;
     * 1 dropdown open
     */
    var state = 0;

    // set feedbackBox hooks
    feedbackBox.on({
        preOptionClick: function preOptionClick(optionData) {

            if (optionData.score < 0) {

                return this.waitForFeedback(this).then(function (comment) {

                    feedbackBox.showThanks(optionData.score);
                    optionData.comment = comment;
                }, function () {});
            } else {

                feedbackBox.showThanks(optionData.score);
            }
        },
        postOptionClick: function postOptionClick(optionData) {

            //cong requirement: negative feedback message should not disappear
            if (optionData.score >= 0) {

                setTimeout(function () {

                    element.style.display = '';
                }, 3500);
            }
        }
    });

    feedbackBox.showDropdown = function () {

        state = 1;
        element.querySelector('[data-dcx-feedbackbox-dropdown]').style.display = 'block';
        element.querySelector('.optionno').classList.add("selected");
    };

    feedbackBox.hideDropdown = function () {

        state = 0;
        element.querySelector('[data-dcx-feedbackbox-dropdown]').style.display = '';
        element.querySelector(".optionno").classList.remove("selected");
    };

    feedbackBox.showThanks = function (score) {

        var feedbackThanks = void 0;

        if (score >= 0) {

            feedbackThanks = '.etthankspositive';
            element.querySelector('.etthankspositive').style.display = 'block';
            element.querySelector('.etthanksnegative').style.display = '';
        } else {

            feedbackThanks = '.etthanksnegative';
            element.querySelector('.etthanksnegative').style.display = 'block';
            element.querySelector('.etthankspositive').style.display = '';
        }

        feedbackBox.hideCommentBox();
        feedbackBox.hideDropdown();
        element.querySelector('.feedbackSelection').style.display = 'none';

        if (score >= 0) {
            //cong requirement: negative feedback message should not disappear
            setTimeout(function () {

                element.querySelector(feedbackThanks).style.display = '';
            }, 3500);
        }
    };

    feedbackBox.hideThanks = function () {

        element.querySelector('.etthankspositive').style.display = '';
        element.querySelector('.etthanksnegative').style.display = '';
    };

    feedbackBox.showCommentBox = function () {

        element.querySelector('.feedbackcomment').style.display = 'block';
    };

    feedbackBox.hideCommentBox = function () {

        element.querySelector('.feedbackcomment').style.display = '';
    };

    /* initial states */
    feedbackBox.hideDropdown();
    feedbackBox.hideThanks();
    feedbackBox.hideCommentBox();

    var continueAfterClick = null;

    feedbackBox.waitForFeedback = function (ele) {

        if (state == 1) {

            feedbackBox.hideDropdown();
        } else {

            feedbackBox.showDropdown();

            if (!dcx.utils.isOldiOs() && $scrollableContainer) {

                var topPos = ele.element.offsetTop;

                $scrollableContainer.scrollTop = topPos;
            }
        }

        return new Promise(function (resolve, reject) {

            continueAfterClick = resolve;
        });
    };

    var lis = element.querySelectorAll('[data-dcx-feedbackbox-dropdown] > li');

    for (var i = 0, l = lis.length; i < l; i++) {

        lis[i].addEventListener('click', function (e) {

            feedbackBox.hideDropdown();
            var parent = e.currentTarget;

            if (parent.dataset.toggleFeedback == 1) {

                feedbackBox.showCommentBox();
            } else {

                continueAfterClick(parent.querySelector('span').innerText);
            }
        });
    }

    element.querySelector('.feedbackprevious').addEventListener('click', function (e) {

        e.preventDefault();
        feedbackBox.hideCommentBox();
        feedbackBox.showDropdown();
    });

    element.querySelector('.submitfeedback').addEventListener('click', function (e) {
        //get last element value
        e.preventDefault();
        var ele = element.querySelectorAll('.feedbacktextarea')[element.querySelectorAll('.feedbacktextarea').length - 1];
        continueAfterClick(ele.value);
    });

    element.querySelector('.feedbacktextarea').addEventListener('input', function (e) {

        var val = element.querySelector('.feedbacktextarea').value;

        if (val !== '') {

            element.querySelector('.submitfeedback').removeAttribute("disabled");
        } else {

            element.querySelector('.submitfeedback').setAttribute("disabled", "disabled");
        }
    });

    return feedbackBox;
};

},{"./index.js":12}],12:[function(require,module,exports){
"use strict";

module.exports = function (dcx, element, id, component) {

    var feedbackBox = dcx.FeedbackBox(id, element);

    return feedbackBox;
};

},{}],13:[function(require,module,exports){
"use strict";

module.exports = function () {

    return [

    // root
    { url: /(congstar|nicotua|nicotuadev)\.de\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /www.congstar-forum.de\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /freundewerben.congstar.de\/$/, settings: { classificationId: 97, categoryId: 712 } },

    // one level deep
    { url: /(congstar|nicotua|nicotuadev)\.de\/agb\/$/, settings: { classificationId: 97, categoryId: 740 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/datenschutz\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/garantiebedingungen\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/$/, settings: { classificationId: 97, categoryId: 1506 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/impressum\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/login\/$/, settings: { classificationId: 97, categoryId: 1249 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/meincongstar\/$/, settings: { classificationId: 97, categoryId: 1249 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/prepaid\/$/, settings: { classificationId: 97, categoryId: 1505 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/produktinformationsblaetter\/$/, settings: { classificationId: 97, categoryId: 1506 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/verbraucherinformation\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/werben-und-verdienen\/$/, settings: { classificationId: 97, categoryId: 712 } }, { url: /www.congstar-forum.de\/foren-uebersicht\/$/, settings: { classificationId: 97, categoryId: 647 } },

    // two levels
    { url: /(congstar|nicotua|nicotuadev)\.de\/angebote\/young\/$/, settings: { classificationId: 97, categoryId: 1506 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/congstar-wg\/karneval-2019\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/auszeichnungen\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/diy-tipps\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/fc-st-pauli\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/handy-hacks\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/jobs-karriere\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/newsletter\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/presse-bereich\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/smartphone-sicherheit\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/soziales-engagement\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/unternehmen\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/datentarife-vergleich\/$/, settings: { classificationId: 97, categoryId: 1474 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/alle-handys\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/apple\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/bestenlisten\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/gebrauchte-handys\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/handy-angebote\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/handytausch-option\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/huawei\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/neue-handys-und-smartphones\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/samsung\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/sony\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/top-handyvergleich\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/congstar-homespot-im-vergleich\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/homespot-30\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/homespot-100\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/homespot-200\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/homespot-wlan-router\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/homespot-einrichten\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/mobiles-internet\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/homespot-fachhandel\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/lg\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/technik-news-trends\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/wlan-router\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/zubehoer\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/basic-tarif\/$/, settings: { classificationId: 97, categoryId: 1506 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/fair-flat\/$/, settings: { classificationId: 97, categoryId: 1506 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/musik-option-tidal-premium\/$/, settings: { classificationId: 97, categoryId: 742 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/smartphone-tarife-im-vergleich\/$/, settings: { classificationId: 97, categoryId: 1506 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/tarif-vorteile\/$/, settings: { classificationId: 97, categoryId: 1506 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/agb\/$/, settings: { classificationId: 97, categoryId: 740 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/bestellung-versand\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/downloads\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/handy-lexikon\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/roaming\/$/, settings: { classificationId: 97, categoryId: 740 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/infos\/garantiebedingungen\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/meincongstar\/meine-daten\/$/, settings: { classificationId: 97, categoryId: 711 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/meincongstar\/meine-produkte\/$/, settings: { classificationId: 97, categoryId: 679 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/meincongstar\/meine-rechnungen\/$/, settings: { classificationId: 97, categoryId: 680 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/prepaid\/internet-stick\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/prepaid\/karte-aktivieren-und-legitimieren\/$/, settings: { classificationId: 97, categoryId: 677 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/prepaid\/karte-aktivieren\/$/, settings: { classificationId: 97, categoryId: 677 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/prepaid\/prepaid-tarife-vergleich\/$/, settings: { classificationId: 97, categoryId: 1505 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/werben-und-verdienen\/partnerprogramm\/$/, settings: { classificationId: 97, categoryId: 712 } },

    // three levels deep
    { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/handyvergleich\/apple-iphone-vergleich\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/service\/handyversicherung\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/service\/handy-verkaufen\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/datentarife\/daten-l\/$/, settings: { classificationId: 97, categoryId: 1474 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/datentarife\/daten-m\/$/, settings: { classificationId: 97, categoryId: 1474 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/datentarife\/daten-s\/$/, settings: { classificationId: 97, categoryId: 1474 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/auftrag-lieferung\/retoure\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/auftrag-lieferung\/rufnummernmitnahme\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/downloads\/congstar-formulare\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/downloads\/prepaid-internet-stick\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/downloads\/router-und-festnetz\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/kontakt\/congstar-im-telekom-shop\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/kontakt\/kontaktformular\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-handy\/drittanbietersperre-abofalle\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-handy\/gsm-codes\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-handy\/handy-verloren-karte-sperren/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-handy\/handy-vor-diebstahl-schuetzen\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-handy\/sim-karten-formate/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-handy\/sim-karte-tauschen\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-vertrag\/congstar-app\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-vertrag\/handy-tarifwechsel\/$/, settings: { classificationId: 97, categoryId: 679 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-vertrag\/kundendaten-verwalten\/$/, settings: { classificationId: 97, categoryId: 711 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-vertrag\/rufnummer-mitnehmen\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-vertrag\/speedon\/$/, settings: { classificationId: 97, categoryId: 742 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-vertrag\/vertrag-verlaengern\/$/, settings: { classificationId: 97, categoryId: 1507 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-vertrag\/zubuchbare-optionen-postpaid\/$/, settings: { classificationId: 97, categoryId: 742 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-vertrag\/zubuchbare-optionen-prepaid\/$/, settings: { classificationId: 97, categoryId: 742 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/rechnung\/infos-zur-rechnung\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/tablets\/alle-tablets\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/handyvergleich\/samsung-galaxy-vergleich\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/handyvergleich\/sony-xperia-vergleich\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-handy\/handy-hilfe\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/prepaid\/internet-stick\/installieren\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/komplettpakete\/komplett-1\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/komplettpakete\/komplett-2\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/komplettpakete\/komplett-2-vdsl\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/mobiles-internet\/mobiler-wlan-router\/$/, settings: { classificationId: 97, categoryId: 646 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/festnetz-internet\/optionen-services\/zusatzoptionen\/$/, settings: { classificationId: 97, categoryId: 742 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/technik-news-trends\/fingerabdruckscanner\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/technik-news-trends\/mobile-health\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/technik-news-trends\/nfc\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/technik-news-trends\/wasserdichte-smartphones\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/technik-news-trends\/wireless-charging\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/technik-news-trends\/kinderuhren\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handys\/technik-news-trends\/smartphones-unter-400-euro\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/smart-allnet-flat-tarife\/smart-tarif\/$/, settings: { classificationId: 97, categoryId: 1313 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/mein-handy\/handy-reparatur\/$/, settings: { classificationId: 97, categoryId: 678 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/prepaid\/sim-freischalten-legitimation\/$/, settings: { classificationId: 97, categoryId: 677 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/hilfe-service\/rechnung\/infos-zur-rechnung\/$/, settings: { classificationId: 97, categoryId: 1281 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/prepaid\/prepaid-wie-ich-will\/prepaid-karte\/$/, settings: { classificationId: 97, categoryId: 1505 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/prepaid\/prepaid-wie-ich-will\/basic-s\/$/, settings: { classificationId: 97, categoryId: 1505 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/prepaid\/prepaid-wie-ich-will\/allnet-m\/$/, settings: { classificationId: 97, categoryId: 1505 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/prepaid\/prepaid-wie-ich-will\/allnet-l\/$/, settings: { classificationId: 97, categoryId: 1505 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/prepaid\/services\/karte-aufladen\/$/, settings: { classificationId: 97, categoryId: 743 } },

    // four levels deep
    { url: /(congstar|nicotua|nicotuadev)\.de\/das-ist-congstar\/congstar-wg\/outdoor-special\/max-hartung\/$/, settings: { classificationId: 97, categoryId: 647 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/smart-allnet-flat-tarife\/allnet-flat\/$/, settings: { classificationId: 97, categoryId: 741 } }, { url: /(congstar|nicotua|nicotuadev)\.de\/handytarife\/smart-allnet-flat-tarife\/allnet-flat-plus\/$/, settings: { classificationId: 97, categoryId: 741 } }];
};

},{}],14:[function(require,module,exports){
'use strict';

var html = require('./templates/index.tpl');
var dialogOptionTpl = require('./templates/dialogOption.tpl');
var chat = require('../../plugins/chat/index.js');
var _utils = require('../../utils/index.js')();
var pageBasedMapping = require('./faq-mapping.js')();
var faqListTpl = require('./templates/faqs.tpl');
var faqHtml = require('./templates/faqblock.tpl');
//const typeahead = require('dcx-typeahead')
var debug = require('debug')('cxco:va-sl');

module.exports = function (dcx, wrapper, lang) {

    'use strict';
    // inject html

    wrapper.innerHTML = dcx.dot.template(html)(lang);

    // cache elements
    var outputLoader = wrapper.querySelector('.loader');
    var inputWrapperElement = wrapper.querySelector('.cxco-inputWrapper');
    var inputElement = wrapper.querySelector('[data-dcx-input-question]');
    var submitButton = wrapper.querySelector('[data-dcx-input-submit]');
    var chatbox = wrapper.querySelector('[data-dcx-chat-box]');
    var pbFaqListContainer = wrapper.querySelector('[data-dcx-faqlist-pagerelated]');
    var contextualFaqListContainer = wrapper.querySelector('[data-dcx-faqlist-contextual]');
    var $scrollableContainer = wrapper.querySelector('.cxco-scrollable');
    var channel = wrapper.getAttribute('data-cxco-channel');
    var hasChannel = channel !== null && channel !== "";
    var botDelay = 2000;
    var hasInitialized = false;

    // create the va
    var va = dcx.VirtualAssistant('va', wrapper.querySelector('[data-dcx-va]'), {

        minFaqs: 1,
        maxFaqs: 3,
        classificationId: 5,
        dialogOptionTemplate: dialogOptionTpl
    });

    //if data attribute is defined set dim channel to it and hide input
    if (hasChannel) {
        inputWrapperElement.style.display = 'none';
        dcx.settings.context.dim['Channels'] = channel;
    } else {
        //initial height - start screen
        $scrollableContainer.style.height = '100px';
        $scrollableContainer.style.minHeight = '100px';
        inputWrapperElement.style.bottom = '0px';
        // When channel is not checkout enable FAQs by default
        pbFaqListContainer.innerHTML = dcx.dot.template(faqHtml)(lang);
    }

    //CONG requirement: clear storage on refresh
    va.history.clear();

    var chatModule = chat(dcx, va, lang);
    var feedbackBox = void 0;

    dcx.utils.extend(dcx.utils, _utils);

    var pageBasedFaqs = dcx.FaqList('footerFaqList', pbFaqListContainer, {
        template: faqListTpl,
        dialogOptionTemplate: dialogOptionTpl
    });

    pageBasedFaqs.on({
        preGetAnswer: function preGetAnswer(engineResult, id) {
            debug('pageBasedFaqs preGetAnswer');
            outputLoader.style.display = 'block';

            chatModule.addQuestion(Object.assign({}, engineResult));

            //only needs to run once.
            if (!hasInitialized) {

                //cuts pagerelated faqs into the chat container
                contextualFaqListContainer.parentNode.insertBefore(pbFaqListContainer, contextualFaqListContainer.nextSibling);

                $scrollableContainer.style.height = '';
                $scrollableContainer.style.minHeight = '';
                inputWrapperElement.style.bottom = '';
                hasInitialized = true;
            }
        },
        interactionEnd: function interactionEnd(engineResult) {
            debug('pageBasedFaqs interactionEnd');
            outputLoader.style.display = 'none';

            if (!dcx.utils.isUndefined(engineResult)) {

                engineResult.answer = formatDialogList(engineResult.answer);

                impersonate(chatModule.addAnswer(Object.assign({}, engineResult))).then(function () {

                    if (showFeedback(engineResult)) {
                        //make visible
                        var fb = wrapper.querySelector('[data-dcx-feedbackbox="a.' + engineResult.interactionId + '"]');

                        if (fb) {

                            fb.style.display = 'block';

                            if (feedbackBox) {

                                feedbackBox.destroy();
                            }

                            feedbackBox = chatModule.addFeedback(wrapper.querySelector('[data-dcx-feedbackbox="a.' + engineResult.interactionId + '"]'), engineResult.interactionId);

                            feedbackBox.setInteraction(engineResult);
                        }
                    }
                });
            }

            scrollElement();
        },
        error: function error(err) {
            outputLoader.style.display = '';
            debug('pageBasedFaqs error', err);
        }
    });

    var pageBasedFaqSettings = dcx.utils.getPageBasedSettings(pageBasedMapping);

    if (!hasChannel) {
        pageBasedFaqs.getFaqsByCategoryId(pageBasedFaqSettings);
    }

    contextualFaqListContainer.innerHTML = dcx.dot.template(faqHtml)(lang);
    var contextualFaqs = dcx.FaqList('chatFaqList', contextualFaqListContainer, {

        template: faqListTpl,
        dialogOptionTemplate: dialogOptionTpl
    });

    contextualFaqs.on({
        preGetAnswer: function preGetAnswer(engineResult, id) {
            debug('contextualFaqs preGetAnswer');
            outputLoader.style.display = 'block';
            chatModule.addQuestion(Object.assign({}, engineResult));
        },
        interactionEnd: function interactionEnd(engineResult) {
            debug('contextualFaqs interactionEnd');
            outputLoader.style.display = 'none';

            if (!dcx.utils.isUndefined(engineResult) && engineResult.inputType === 'faq') {
                dcx.utils.replaceMedia(engineResult, wrapper.querySelector('.cxco-chatElement--answer'));
                engineResult.answer = formatDialogList(engineResult.answer);

                impersonate(chatModule.addAnswer(Object.assign({}, engineResult))).then(function () {

                    if (showFeedback(engineResult)) {
                        //make visible
                        wrapper.querySelector('[data-dcx-feedbackbox="a.' + engineResult.interactionId + '"]').style.display = 'block';
                        if (feedbackBox) {

                            feedbackBox.destroy();
                        }
                        feedbackBox = chatModule.addFeedback(wrapper.querySelector('[data-dcx-feedbackbox="a.' + engineResult.interactionId + '"]'), engineResult.interactionId);

                        feedbackBox.setInteraction(engineResult);
                    }
                });
            }

            scrollElement();
        },
        error: function error(err) {
            outputLoader.style.display = '';
            debug('contextualFaqs error', err);
        }
    });

    // set VA hooks
    va.on({
        preAsk: function preAsk(options) {
            debug('[hook] preask');
            //only needs to run once.
            if (!hasInitialized) {

                $scrollableContainer.style.height = '';
                $scrollableContainer.style.minHeight = '';
                inputWrapperElement.style.bottom = '';
                hasInitialized = true;
            }

            outputLoader.style.display = 'block';
            chatModule.addQuestion(Object.assign({}, options));
        },
        preShowOutput: function preShowOutput(engineResult) {

            debug('[hook] preShowOutput');

            if (!dcx.utils.isUndefined(engineResult.answer)) {

                //sets contextual FAQs
                if (dcx.utils.isArray(engineResult.faqs) && engineResult.faqs.length > 0 && !hasChannel) {

                    contextualFaqs.setFaqs(engineResult);
                    toggleShowFaqs(true);
                }

                dcx.utils.replaceMedia(engineResult, wrapper.querySelector('.cxco-chatElement--answer'));

                if (engineResult.outputType == "dialog") {

                    engineResult.answer = formatDialogList(engineResult.answer);
                }

                impersonate(chatModule.addAnswer(Object.assign({}, engineResult)));
            }

            if (showFeedback(engineResult)) {
                //make visible
                wrapper.querySelector('[data-dcx-feedbackbox="a.' + engineResult.interactionId + '"]').style.display = 'block';

                if (feedbackBox) {

                    feedbackBox.destroy();
                }

                feedbackBox = chatModule.addFeedback(this.element.querySelector('[data-dcx-feedbackbox="a.' + engineResult.interactionId + '"]'), engineResult.interactionId);

                feedbackBox.setInteraction(engineResult);
            }

            va.clearOutput();
        },
        interactionEnd: function interactionEnd(engineResult) {

            debug('[hook] interactionEnd');

            outputLoader.style.display = 'none';

            scrollElement();

            inputElement.value = "";
        },
        error: function error(err) {

            outputLoader.style.display = '';
            debug('va error', err);
        }
    });

    chatModule.init(chatbox);

    //CHAT interface requirement: focus on input
    //inputElement.focus();

    function formatDialogOptions(element) {

        var dialogOptionLinks = Array.prototype.slice.call(element.querySelectorAll('.dialog-option-link'));
        if (dialogOptionLinks.length > 0) {

            dialogOptionLinks.forEach(function (link) {

                link.parentNode.className = 'dialog-option';
                link.parentNode.parentNode.className = 'dialog-options';
            });
        }
    }

    /**
     * Adds cxco-clickabledialog to ul element.
     */
    function formatDialogList(answer) {

        var ele = parseHTML(answer);

        if (ele.querySelectorAll('ul > li > a').length > 0) {

            //making sure we get the correct root ul with the clickable links.
            //as the answer can contain other list elements.
            try {

                var ul = ele.querySelectorAll('ul > li > a')[0].parentElement.parentElement;
                ul.classList.add('cxco-clickabledialog');

                answer = ul.parentElement.innerHTML;
            } catch (err) {
                //lets try with jquery
                var _ul = $(answer).filter('ul').find('li a').parentsUntil('ul').parent();
                answer = answer.replace($(answer).filter('ul').find('li a').parentsUntil('ul').parent().prop('outerHTML'), _ul.prop('outerHTML'));
            }
        }

        return answer;
    }

    /**
     * Checks if feedback is shown
     */
    function showFeedback(engineResult) {

        if (engineResult.inputType === 'event') {

            return false;
        }

        if (/(onload|escalation|exception)/i.test(engineResult.interactionValue)) {

            return false;
        }

        if (engineResult.outputType === 'dialog' && !engineResult.isDialogEnd) {

            return false;
        }

        try {
            //Congstar specific
            if (engineResult.additions.feedback == 'False') {

                return false;
            }
        } catch (err) {
            //proceed silently
        }

        return true;
    }

    /**
     * Converts a string into a dom element wrapped in a div.
     */
    function parseHTML(htmlStr) {
        var d = document.createElement('div');
        d.innerHTML = htmlStr;
        return d;
    }

    /**
     * adds timeout to give human feel
     */
    function impersonate(func) {

        return new Promise(function (resolve) {

            setTimeout(resolve(func), botDelay);
        });
    }

    /**
     *  Toggle between contextual and page related FAQs
     */
    function toggleShowFaqs(isContextual) {

        if (isContextual) {

            pbFaqListContainer.style.display = 'none';
            contextualFaqListContainer.style.display = 'block';
        } else {

            pbFaqListContainer.style.display = 'block';
            contextualFaqListContainer.style.display = 'none';
        }
    }

    /**
     * Scroll last Question to top of the viewport
     */
    function scrollElement() {

        if (!dcx.utils.isOldiOs()) {

            var myElement = wrapper.querySelector('.' + chatModule.getLastQuestionElement());
            var topPos = myElement.offsetTop;

            $scrollableContainer.scrollTop = topPos;
        }
    }

    /**
     * On Enter keypress submit
     */
    inputElement.addEventListener('keydown', function (event) {

        if (event.which === 13) {

            submitButton.click();
            event.preventDefault();
        }
    });

    // Show answer from storage or send onLoad event
    var last = va.history.get(-1);

    if (!last) {

        va.sendSystemEvent({
            event: 'onLoad'
        }).then(function (engineResult) {

            // Default onLoad answer should not be showed.
            if (hasChannel) {
                return chatModule.addAnswer(Object.assign({}, engineResult));
            }
        });
    }

    return {
        va: va
    };
};

},{"../../plugins/chat/index.js":22,"../../utils/index.js":27,"./faq-mapping.js":13,"./templates/dialogOption.tpl":15,"./templates/faqblock.tpl":16,"./templates/faqs.tpl":17,"./templates/index.tpl":18,"debug":6}],15:[function(require,module,exports){
module.exports = "<a href=\"javascript:void(0);\" data-dcx-dialog-option=\"{{=it.text}}\" data-dcx-dialogpath=\"{{=it.path}}\" class=\"dialog-option-link\"><span class=\"sprite\"></span>{{=it.text}}</a>";

},{}],16:[function(require,module,exports){
module.exports = "<div class=\"cxco-faqlist-title\">Häufig gestellte Fragen</div><ul data-dcx-faqlist-list></ul>";

},{}],17:[function(require,module,exports){
module.exports = "{{~it:faq}}<li class=\"cxco-faqItem clearfix\"><span></span> <a data-dcx-faq=\"{{=faq.id}}\" data-showfaqs=\"true\"href=\"javascript: void(0);\">{{=faq.question}}</a></li> {{~}}<li class=\"cxco-faqItem\"><span></span><a href=\"/hilfe-service/faq\" style=\"color: #0099d5;\">Alle häufig gestellten Fragen</a></li>";

},{}],18:[function(require,module,exports){
module.exports = "<div data-dcx-va><div class=\"cxco-scrollable\"><div data-dcx-chat-box></div><div class=\"loader\"></div><div data-dcx-faqlist-contextual></div></div><div class=\"cxco-inputWrapper\"><div class=\"input-addon\"> <input class=\"input\" placeholder=\"{{=it.input.placeholder}}\" data-dcx-input-question> <button type=\"button\" class=\"input-addon__wrapper input-addon--button\" data-dcx-input-submit><span class=\"icon--arrow-right\"></span></button></div></div><div data-dcx-faqlist-pagerelated></div></div>";

},{}],19:[function(require,module,exports){
var css = "#cxco-placementCategoryblock,#cxco-wrapperFaqblock,#cxco-wrapperVa{/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */font-family:\"Interstate\",Arial,Helvetica,Verdana,sans-serif;font-size:14px;line-height:24px;color:#222}#cxco-placementCategoryblock html,#cxco-wrapperFaqblock html,#cxco-wrapperVa html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}#cxco-placementCategoryblock body,#cxco-wrapperFaqblock body,#cxco-wrapperVa body{margin:0}#cxco-placementCategoryblock article,#cxco-placementCategoryblock aside,#cxco-placementCategoryblock details,#cxco-placementCategoryblock figcaption,#cxco-placementCategoryblock figure,#cxco-placementCategoryblock footer,#cxco-placementCategoryblock header,#cxco-placementCategoryblock hgroup,#cxco-placementCategoryblock main,#cxco-placementCategoryblock menu,#cxco-placementCategoryblock nav,#cxco-placementCategoryblock section,#cxco-placementCategoryblock summary,#cxco-wrapperFaqblock article,#cxco-wrapperFaqblock aside,#cxco-wrapperFaqblock details,#cxco-wrapperFaqblock figcaption,#cxco-wrapperFaqblock figure,#cxco-wrapperFaqblock footer,#cxco-wrapperFaqblock header,#cxco-wrapperFaqblock hgroup,#cxco-wrapperFaqblock main,#cxco-wrapperFaqblock menu,#cxco-wrapperFaqblock nav,#cxco-wrapperFaqblock section,#cxco-wrapperFaqblock summary,#cxco-wrapperVa article,#cxco-wrapperVa aside,#cxco-wrapperVa details,#cxco-wrapperVa figcaption,#cxco-wrapperVa figure,#cxco-wrapperVa footer,#cxco-wrapperVa header,#cxco-wrapperVa hgroup,#cxco-wrapperVa main,#cxco-wrapperVa menu,#cxco-wrapperVa nav,#cxco-wrapperVa section,#cxco-wrapperVa summary{display:block}#cxco-placementCategoryblock audio,#cxco-placementCategoryblock canvas,#cxco-placementCategoryblock progress,#cxco-placementCategoryblock video,#cxco-wrapperFaqblock audio,#cxco-wrapperFaqblock canvas,#cxco-wrapperFaqblock progress,#cxco-wrapperFaqblock video,#cxco-wrapperVa audio,#cxco-wrapperVa canvas,#cxco-wrapperVa progress,#cxco-wrapperVa video{display:inline-block;vertical-align:baseline}#cxco-placementCategoryblock audio:not([controls]),#cxco-wrapperFaqblock audio:not([controls]),#cxco-wrapperVa audio:not([controls]){display:none;height:0}#cxco-placementCategoryblock [hidden],#cxco-placementCategoryblock template,#cxco-wrapperFaqblock [hidden],#cxco-wrapperFaqblock template,#cxco-wrapperVa [hidden],#cxco-wrapperVa template{display:none}#cxco-placementCategoryblock a,#cxco-wrapperFaqblock a,#cxco-wrapperVa a{background-color:transparent}#cxco-placementCategoryblock a:active,#cxco-placementCategoryblock a:hover,#cxco-wrapperFaqblock a:active,#cxco-wrapperFaqblock a:hover,#cxco-wrapperVa a:active,#cxco-wrapperVa a:hover{outline:0}#cxco-placementCategoryblock abbr[title],#cxco-wrapperFaqblock abbr[title],#cxco-wrapperVa abbr[title]{border-bottom:1px dotted}#cxco-placementCategoryblock b,#cxco-placementCategoryblock strong,#cxco-wrapperFaqblock b,#cxco-wrapperFaqblock strong,#cxco-wrapperVa b,#cxco-wrapperVa strong{font-weight:700}#cxco-placementCategoryblock dfn,#cxco-wrapperFaqblock dfn,#cxco-wrapperVa dfn{font-style:italic}#cxco-placementCategoryblock h1,#cxco-wrapperFaqblock h1,#cxco-wrapperVa h1{font-size:2em;margin:.67em 0}#cxco-placementCategoryblock mark,#cxco-wrapperFaqblock mark,#cxco-wrapperVa mark{background:#ff0;color:#000}#cxco-placementCategoryblock small,#cxco-wrapperFaqblock small,#cxco-wrapperVa small{font-size:80%}#cxco-placementCategoryblock sub,#cxco-placementCategoryblock sup,#cxco-wrapperFaqblock sub,#cxco-wrapperFaqblock sup,#cxco-wrapperVa sub,#cxco-wrapperVa sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}#cxco-placementCategoryblock sup,#cxco-wrapperFaqblock sup,#cxco-wrapperVa sup{top:-.5em}#cxco-placementCategoryblock sub,#cxco-wrapperFaqblock sub,#cxco-wrapperVa sub{bottom:-.25em}#cxco-placementCategoryblock img,#cxco-wrapperFaqblock img,#cxco-wrapperVa img{border:0}#cxco-placementCategoryblock svg:not(:root),#cxco-wrapperFaqblock svg:not(:root),#cxco-wrapperVa svg:not(:root){overflow:hidden}#cxco-placementCategoryblock figure,#cxco-wrapperFaqblock figure,#cxco-wrapperVa figure{margin:1em 40px}#cxco-placementCategoryblock hr,#cxco-wrapperFaqblock hr,#cxco-wrapperVa hr{box-sizing:content-box;height:0}#cxco-placementCategoryblock pre,#cxco-wrapperFaqblock pre,#cxco-wrapperVa pre{overflow:auto}#cxco-placementCategoryblock code,#cxco-placementCategoryblock kbd,#cxco-placementCategoryblock pre,#cxco-placementCategoryblock samp,#cxco-wrapperFaqblock code,#cxco-wrapperFaqblock kbd,#cxco-wrapperFaqblock pre,#cxco-wrapperFaqblock samp,#cxco-wrapperVa code,#cxco-wrapperVa kbd,#cxco-wrapperVa pre,#cxco-wrapperVa samp{font-family:monospace,monospace;font-size:1em}#cxco-placementCategoryblock button,#cxco-placementCategoryblock input,#cxco-placementCategoryblock optgroup,#cxco-placementCategoryblock select,#cxco-placementCategoryblock textarea,#cxco-wrapperFaqblock button,#cxco-wrapperFaqblock input,#cxco-wrapperFaqblock optgroup,#cxco-wrapperFaqblock select,#cxco-wrapperFaqblock textarea,#cxco-wrapperVa button,#cxco-wrapperVa input,#cxco-wrapperVa optgroup,#cxco-wrapperVa select,#cxco-wrapperVa textarea{color:inherit;font:inherit;margin:0}#cxco-placementCategoryblock button,#cxco-wrapperFaqblock button,#cxco-wrapperVa button{overflow:visible}#cxco-placementCategoryblock button,#cxco-placementCategoryblock select,#cxco-wrapperFaqblock button,#cxco-wrapperFaqblock select,#cxco-wrapperVa button,#cxco-wrapperVa select{text-transform:none}#cxco-placementCategoryblock button,#cxco-placementCategoryblock html input[type=button],#cxco-placementCategoryblock input[type=reset],#cxco-placementCategoryblock input[type=submit],#cxco-wrapperFaqblock button,#cxco-wrapperFaqblock html input[type=button],#cxco-wrapperFaqblock input[type=reset],#cxco-wrapperFaqblock input[type=submit],#cxco-wrapperVa button,#cxco-wrapperVa html input[type=button],#cxco-wrapperVa input[type=reset],#cxco-wrapperVa input[type=submit]{-webkit-appearance:button;cursor:pointer}#cxco-placementCategoryblock button[disabled],#cxco-placementCategoryblock html input[disabled],#cxco-wrapperFaqblock button[disabled],#cxco-wrapperFaqblock html input[disabled],#cxco-wrapperVa button[disabled],#cxco-wrapperVa html input[disabled]{cursor:default}#cxco-placementCategoryblock button::-moz-focus-inner,#cxco-placementCategoryblock input::-moz-focus-inner,#cxco-wrapperFaqblock button::-moz-focus-inner,#cxco-wrapperFaqblock input::-moz-focus-inner,#cxco-wrapperVa button::-moz-focus-inner,#cxco-wrapperVa input::-moz-focus-inner{border:0;padding:0}#cxco-placementCategoryblock input,#cxco-wrapperFaqblock input,#cxco-wrapperVa input{line-height:normal}#cxco-placementCategoryblock input[type=checkbox],#cxco-placementCategoryblock input[type=radio],#cxco-wrapperFaqblock input[type=checkbox],#cxco-wrapperFaqblock input[type=radio],#cxco-wrapperVa input[type=checkbox],#cxco-wrapperVa input[type=radio]{box-sizing:border-box;padding:0}#cxco-placementCategoryblock input[type=number]::-webkit-inner-spin-button,#cxco-placementCategoryblock input[type=number]::-webkit-outer-spin-button,#cxco-wrapperFaqblock input[type=number]::-webkit-inner-spin-button,#cxco-wrapperFaqblock input[type=number]::-webkit-outer-spin-button,#cxco-wrapperVa input[type=number]::-webkit-inner-spin-button,#cxco-wrapperVa input[type=number]::-webkit-outer-spin-button{height:auto}#cxco-placementCategoryblock input[type=search],#cxco-wrapperFaqblock input[type=search],#cxco-wrapperVa input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}#cxco-placementCategoryblock input[type=search]::-webkit-search-cancel-button,#cxco-placementCategoryblock input[type=search]::-webkit-search-decoration,#cxco-wrapperFaqblock input[type=search]::-webkit-search-cancel-button,#cxco-wrapperFaqblock input[type=search]::-webkit-search-decoration,#cxco-wrapperVa input[type=search]::-webkit-search-cancel-button,#cxco-wrapperVa input[type=search]::-webkit-search-decoration{-webkit-appearance:none}#cxco-placementCategoryblock fieldset,#cxco-wrapperFaqblock fieldset,#cxco-wrapperVa fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}#cxco-placementCategoryblock legend,#cxco-wrapperFaqblock legend,#cxco-wrapperVa legend{border:0;padding:0}#cxco-placementCategoryblock textarea,#cxco-wrapperFaqblock textarea,#cxco-wrapperVa textarea{overflow:auto}#cxco-placementCategoryblock optgroup,#cxco-wrapperFaqblock optgroup,#cxco-wrapperVa optgroup{font-weight:700}#cxco-placementCategoryblock table,#cxco-wrapperFaqblock table,#cxco-wrapperVa table{border-collapse:collapse;border-spacing:0}#cxco-placementCategoryblock td,#cxco-placementCategoryblock th,#cxco-wrapperFaqblock td,#cxco-wrapperFaqblock th,#cxco-wrapperVa td,#cxco-wrapperVa th{padding:0}#cxco-placementCategoryblock,#cxco-placementCategoryblock *,#cxco-wrapperFaqblock,#cxco-wrapperFaqblock *,#cxco-wrapperVa,#cxco-wrapperVa *{box-sizing:border-box}#cxco-placementCategoryblock button,#cxco-placementCategoryblock input,#cxco-placementCategoryblock textarea,#cxco-wrapperFaqblock button,#cxco-wrapperFaqblock input,#cxco-wrapperFaqblock textarea,#cxco-wrapperVa button,#cxco-wrapperVa input,#cxco-wrapperVa textarea{outline:0;resize:none}#cxco-placementCategoryblock input::-ms-clear,#cxco-wrapperFaqblock input::-ms-clear,#cxco-wrapperVa input::-ms-clear{display:none!important}#cxco-placementCategoryblock .placeholder,#cxco-wrapperFaqblock .placeholder,#cxco-wrapperVa .placeholder{color:#222!important}#cxco-placementCategoryblock .loader,#cxco-placementCategoryblock .loader:after,#cxco-placementCategoryblock .loader:before,#cxco-wrapperFaqblock .loader,#cxco-wrapperFaqblock .loader:after,#cxco-wrapperFaqblock .loader:before,#cxco-wrapperVa .loader,#cxco-wrapperVa .loader:after,#cxco-wrapperVa .loader:before{border-radius:50%;width:2.5em;height:2.5em;animation:load7 1s infinite ease-in-out}#cxco-placementCategoryblock .loader,#cxco-wrapperFaqblock .loader,#cxco-wrapperVa .loader{color:#959595;font-size:5px;margin:10px 25px;position:relative;text-indent:-9999em;transform:translateZ(0);animation-delay:-.16s;display:none}#cxco-placementCategoryblock .loader:after,#cxco-placementCategoryblock .loader:before,#cxco-wrapperFaqblock .loader:after,#cxco-wrapperFaqblock .loader:before,#cxco-wrapperVa .loader:after,#cxco-wrapperVa .loader:before{content:'';position:absolute;top:0}#cxco-placementCategoryblock .loader:before,#cxco-wrapperFaqblock .loader:before,#cxco-wrapperVa .loader:before{left:-3.5em;animation-delay:-.32s}#cxco-placementCategoryblock .loader:after,#cxco-wrapperFaqblock .loader:after,#cxco-wrapperVa .loader:after{left:3.5em}@keyframes load7{0%,100%,80%{box-shadow:0 2.5em 0 -1.3em}40%{box-shadow:0 2.5em 0 0}}#cxco-placementCategoryblock .sprite,#cxco-wrapperFaqblock .sprite,#cxco-wrapperVa .sprite{background-color:transparent;background-repeat:no-repeat;background-position:0 0}#cxco-placementCategoryblock .clearfix:after,#cxco-placementCategoryblock .clearfix:before,#cxco-wrapperFaqblock .clearfix:after,#cxco-wrapperFaqblock .clearfix:before,#cxco-wrapperVa .clearfix:after,#cxco-wrapperVa .clearfix:before{content:\"\";display:table}#cxco-placementCategoryblock .clearfix:after,#cxco-wrapperFaqblock .clearfix:after,#cxco-wrapperVa .clearfix:after{clear:both}#cxco-placementCategoryblock .middleColumn,#cxco-wrapperFaqblock .middleColumn,#cxco-wrapperVa .middleColumn{max-width:940px;margin:0 auto;padding:20px 0}#cxco-placementCategoryblock [data-dcx-backbutton],#cxco-wrapperFaqblock [data-dcx-backbutton],#cxco-wrapperVa [data-dcx-backbutton]{margin-top:20px;cursor:pointer;height:32px;line-height:24px}#cxco-placementCategoryblock [data-dcx-backbutton] p,#cxco-wrapperFaqblock [data-dcx-backbutton] p,#cxco-wrapperVa [data-dcx-backbutton] p{line-height:34px;margin:0 0 0 10px;float:left}#cxco-placementCategoryblock [data-dcx-backbutton]:hover p,#cxco-wrapperFaqblock [data-dcx-backbutton]:hover p,#cxco-wrapperVa [data-dcx-backbutton]:hover p{text-decoration:underline}#cxco-placementCategoryblock [data-dcx-backbutton] .arrow-back,#cxco-wrapperFaqblock [data-dcx-backbutton] .arrow-back,#cxco-wrapperVa [data-dcx-backbutton] .arrow-back{display:block;height:32px;width:32px;background-color:#FFF;padding:7px 11px;border-radius:20px;float:left}#cxco-placementCategoryblock [data-dcx-backbutton] .arrow-back span,#cxco-wrapperFaqblock [data-dcx-backbutton] .arrow-back span,#cxco-wrapperVa [data-dcx-backbutton] .arrow-back span{position:relative;display:inline-block;width:8px;height:16px;overflow:hidden}#cxco-placementCategoryblock [data-dcx-backbutton] .arrow-back span:before,#cxco-wrapperFaqblock [data-dcx-backbutton] .arrow-back span:before,#cxco-wrapperVa [data-dcx-backbutton] .arrow-back span:before{content:\"\";display:block;position:absolute;top:0;left:0;width:0;height:0;border-style:solid;border-width:8px 8px 8px 0;border-color:transparent #008BD0 transparent transparent}#cxco-placementCategoryblock [data-dcx-backbutton] .arrow-back span:after,#cxco-wrapperFaqblock [data-dcx-backbutton] .arrow-back span:after,#cxco-wrapperVa [data-dcx-backbutton] .arrow-back span:after{content:\"\";display:block;position:absolute;top:0;width:0;height:0;border-style:solid;border-width:8px 8px 8px 0;border-color:transparent #FFF transparent transparent;left:3px}[data-dcx-chat-box] .cxco-chatElement .cxco-chatElement--answer,[data-dcx-chat-box] .cxco-chatElement .cxco-chatElement--question,[data-dcx-faqlist-list]{margin:10px 0;padding:15px;border-radius:5px;width:100%;position:relative}[data-dcx-chat-box] .cxco-chatElement .cxco-chatElement--answer p:only-child,[data-dcx-chat-box] .cxco-chatElement .cxco-chatElement--question p:only-child,[data-dcx-faqlist-list] p:only-child{margin-bottom:0}.input-addon--button{padding:7px 13px;color:#FFF!important;background-color:#55BBE9!important;text-decoration:none}.input-addon--button>span:before{padding:0}.cxco-scrollable{background-color:#fff;padding:0 20px;overflow-y:auto;height:calc(100% - 80px)}[data-dcx-chat-box] .cxco-chatElement .cxco-chatElement--question{color:#FFF;background-color:#55BBE9}[data-dcx-chat-box] .cxco-chatElement .cxco-chatElement--question:before{position:absolute;bottom:5px;right:-15px;content:'';border-right:15px solid transparent;border-bottom:22px solid #55BBE9;border-left:0 solid transparent}[data-dcx-chat-box] .cxco-chatElement .cxco-chatElement--answer{color:#000;background-color:#E5E5E5}[data-dcx-chat-box] .cxco-chatElement .cxco-chatElement--answer:before{position:absolute;bottom:5px;left:-15px;content:'';border-right:0 solid transparent;border-bottom:22px solid #E5E5E5;border-left:15px solid transparent}[data-dcx-chat-box] .cxco-chatElement .cxco-chatElement--answer a{color:#000;text-decoration:none;border-bottom:2px solid #000}[data-dcx-chat-box] .cxco-chatElement .cxco-chatElement--answer a:hover{color:#008BD0;border-bottom:2px solid #008BD0}[data-dcx-chat-box] ul.cxco-clickabledialog{padding:0}[data-dcx-chat-box] ul.cxco-clickabledialog li{background-color:#FFF;list-style:none;border:1px solid #55BBE9;margin-bottom:10px;text-align:center;border-radius:5px;cursor:pointer}[data-dcx-chat-box] ul.cxco-clickabledialog li [data-dcx-dialog-option]{display:block;color:#55BBE9;text-decoration:none;font-weight:600;border:none;padding:10px}[data-dcx-chat-box] ul.cxco-clickabledialog li:hover{background-color:#55BBE9;color:#FFF}[data-dcx-chat-box] ul.cxco-clickabledialog li:hover a{color:#FFF;border:none;display:inline-block;width:100%}[data-dcx-chat-box] ul.cxco-clickabledialog li:hover a:hover{color:#FFF!important;border:none}[data-dcx-chat-box] ol{padding-left:1em}[data-dcx-feedbackbox]{position:relative;margin:0 auto;display:none}[data-dcx-feedbackbox] a{color:#000;text-decoration:none;border-bottom:2px solid #000}[data-dcx-feedbackbox] a:hover{color:#008BD0;border-bottom:2px solid #008BD0}[data-dcx-feedbackbox] .feedbackBox{padding:10px 0}[data-dcx-feedbackbox] .feedbackBox .feedbackSelection{font-size:14px;display:inline-block;margin-top:5px;width:100%}[data-dcx-feedbackbox] .feedbackBox .feedbackSelection .feedbackTitle{margin-bottom:10px}[data-dcx-feedbackbox] .feedbackBox .feedbackSelection .option{position:relative;display:inline-block;cursor:pointer;width:40%;max-width:150px;height:40px;margin-bottom:0;border:1px solid #959595;text-align:center;line-height:40px;border-radius:5px;background-color:#FFF;transition:background-color .2s ease-in-out}[data-dcx-feedbackbox] .feedbackBox .feedbackSelection .option input[type=radio]{visibility:hidden;width:0}[data-dcx-feedbackbox] .feedbackBox .feedbackSelection .option:before{display:none;content:none}[data-dcx-feedbackbox] .feedbackBox .feedbackSelection .option:hover{background-color:#B4B4B4}[data-dcx-feedbackbox] .feedbackBox .feedbackSelection .option.selected{color:#000;box-shadow:0 2px 2px rgba(0,0,0,.1)}[data-dcx-feedbackbox] .feedbackBox .etthanks{font-weight:700}[data-dcx-feedbackbox] .feedbackBox .etthanks .etthanksnegative,[data-dcx-feedbackbox] .feedbackBox .etthanks .etthankspositive{display:none}[data-dcx-feedbackbox-dropdown]{display:none;list-style:none;padding-left:0;margin-top:5px;margin-bottom:0;background-color:#FFF;border-radius:6px;border:1px solid #D2D2D2;box-shadow:0 2px 5px rgba(0,0,0,.25)}[data-dcx-feedbackbox-dropdown] li{position:relative;font-size:14px;font-weight:400;line-height:1.5;color:#333;cursor:pointer;min-height:40px;padding:5px;border-bottom:1px solid #B4B4B4}[data-dcx-feedbackbox-dropdown] li:last-child{border-bottom:none}[data-dcx-feedbackbox-dropdown] li .feedbackprefix{display:inline-block;width:100px;color:#B4B4B4;transition:color .2s ease-in-out}[data-dcx-feedbackbox-dropdown] li span{display:inline-block;transition:color .2s ease-in-out}[data-dcx-feedbackbox-dropdown] li b{transition:all .2s ease-in-out}[data-dcx-feedbackbox-dropdown] li:hover b{color:#008BD0}.feedbackcomment{display:none;padding:10px;margin-bottom:0;margin-top:5px;font-size:12px;background-color:#FFF;border-radius:6px;border:1px solid #D2D2D2;box-shadow:0 2px 5px rgba(0,0,0,.25)}.feedbackcomment .feedbackprevious:hover{color:#008BD0}.feedbackcomment .feedbackcommenttitle{display:inline-block}.feedbackcomment .feedbacktextarea{display:block;resize:none;margin-top:5px;font-size:14px;line-height:24px;background-color:#FFF;border:1px solid #959595;border-radius:4px;width:100%;padding:10px 15px;transition:border .2s ease-in-out}.feedbackcomment .etfeedbackcommentbuttons{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;margin-top:10px}.feedbackcomment .feedbackprevious,.feedbackcomment .submitfeedback{position:relative;display:inline-block;cursor:pointer;width:40%;max-width:150px;height:40px;margin-bottom:0;border:1px solid #959595;text-align:center;line-height:40px;border-radius:5px;background-color:#FFF;transition:background-color .2s ease-in-out}.feedbackcomment .feedbackprevious:hover,.feedbackcomment .submitfeedback:hover{background-color:#B4B4B4}.feedbackcomment .feedbackprevious:disabled,.feedbackcomment .submitfeedback:disabled{background-color:#D2D2D2;color:#FFF!important}.cxco-faqlist-title{margin-top:20px;font-weight:700}[data-dcx-faqlist-pagerelated]{position:relative}[data-dcx-faqlist-pagerelated] .cxco-faqlist-title{padding:0 20px}[data-dcx-faqlist-contextual]{display:none}.cxco-scrollable .cxco-faqlist-title{padding:0}.cxco-scrollable [data-dcx-faqlist-list]{padding:20px 0}[data-dcx-faqlist-list]{color:#000;border:none;width:100%;margin:0 auto}[data-dcx-faqlist-list] .cxco-faqItem{font-size:13px;list-style:none}[data-dcx-faqlist-list] .cxco-faqItem span{margin:2px 0 -3px;position:relative;display:inline-block;width:8px;height:16px;overflow:hidden}[data-dcx-faqlist-list] .cxco-faqItem span:before{content:\"\";display:block;position:absolute;top:0;left:0;width:0;height:0;border-style:solid;border-width:8px 0 8px 8px;border-color:transparent}[data-dcx-faqlist-list] .cxco-faqItem span:after{content:\"\";display:block;position:absolute;top:0;width:0;height:0;border-style:solid;border-width:8px 0 8px 8px;border-color:transparent transparent transparent #000;left:-2px}[data-dcx-faqlist-list] .cxco-faqItem a{text-decoration:none;border-bottom:1px solid transparent;color:#000}[data-dcx-faqlist-list] .cxco-faqItem a:hover{border-bottom:1px solid #000}#cxco-wrapperVa{width:100%;height:100%;margin:0;padding:5px 0;color:#222;background-color:#FFF;position:absolute}#cxco-wrapperVa [data-dcx-va]{width:100%;min-width:200px;max-width:960px;height:100%;margin:0 auto}#cxco-wrapperVa [data-dcx-va] .cxco-inputWrapper{padding:15px;position:relative;bottom:0;width:100%;max-height:130px;background-color:#FFF;z-index:3}#cxco-wrapperVa [data-dcx-va] .cxco-inputWrapper [data-dcx-input-question]{padding-right:55px}#cxco-wrapperVa .typeahead-ul{border-radius:5px;border:1px solid #B4B4B4;background-color:#fff;width:100%;list-style:none;padding:0;margin:0}#cxco-wrapperVa .typeahead-ul li{padding:10px 10px 10px 15px}#cxco-wrapperVa .typeahead-ul li.typeahead-is-active{background-color:rgba(85,187,233,.5)}#cxco-wrapperVa .cxco-video{cursor:pointer}.basicLightbox{position:fixed;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.8);opacity:.01;transition:opacity .4s cubic-bezier(0.51,.92,.24,1);z-index:1000;will-change:opacity}.basicLightbox--visible{opacity:1}.basicLightbox__placeholder{max-width:100%;transform:scale(0.9);transition:transform .4s cubic-bezier(0.51,.92,.24,1);z-index:1;will-change:transform}.basicLightbox__placeholder>img:first-child:last-child{display:block;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;max-width:95%;max-height:95%;width:auto;height:auto}.basicLightbox__placeholder>iframe:first-child:last-child{display:block;margin:0 auto;max-width:95%}.basicLightbox__placeholder>[data-basicLightbox]{display:block!important}.basicLightbox--img .basicLightbox__placeholder{width:100%;height:100%;pointer-events:none}.basicLightbox--visible .basicLightbox__placeholder{transform:scale(1)}[data-basicLightbox]{display:none!important}.basicLightbox__close{width:30px;height:30px;background-color:#B4B4B4;position:absolute;right:0;top:-30px;cursor:pointer;border-top-left-radius:5px;border-top-right-radius:5px}.basicLightbox__close svg{margin:5px}"; (require("browserify-css").createStyle(css, {}, { "insertAt": "bottom" })); module.exports = css;
},{"browserify-css":3}],20:[function(require,module,exports){
'use strict';

// default requires
var config = require('./project.config.js');

// Add the context for the form
if (/congstar.de\/hilfe-service\/kontakt\/kontaktformular/.test(window.location.href)) {
    config.context.dim['Channels'] = 'KontaktFormular';
}

var dcx = require('dcx-wasabi')(config);
var Promise = require('promise-polyfill');

// polyfilles
require('../lib/js/polyfills.js');
// To add to window
if (!window.Promise) {
    window.Promise = Promise;
}

// css
var css = require('./css/index.css');

// resources
var lang = require('./resources/')(config.project.culture);

//load jQuery if it's not present.
if (typeof jQuery == 'undefined') {

    getScript('//cdnjs.cloudflare.com/ajax/libs/jquery/3.1.0/jquery.min.js', function () {});
}

// dcx components
var VirtualAssistant = require('./components/virtual-assistant/');

function getScript(url, success) {

    var script = document.createElement('script');
    script.src = url;

    var head = document.getElementsByTagName('head')[0],
        done = false;

    // Attach handlers for all browsers
    script.onload = script.onreadystatechange = function () {

        if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {

            done = true;

            // callback function provided as param
            success();

            script.onload = script.onreadystatechange = null;
            head.removeChild(script);
        }
    };

    head.appendChild(script);
}

module.exports = function () {

    'use strict';

    var isDomLoaded = function isDomLoaded() {
        var vaElmOld = document.querySelector('#etva-sl');
        var vaElm = document.querySelector('#cxco-wrapperVa');

        // Loop until element is in DOM
        if (vaElmOld !== null || vaElm !== null) {

            // convert old placement tags to new ones
            if (dcx.utils.isElement(vaElmOld)) {

                vaElmOld.setAttribute('id', 'cxco-wrapperVa');
                vaElmOld.className = 'wrapper';
                window.requestAnimationFrame(isDomLoaded);
            }

            if (dcx.utils.isElement(vaElm)) {

                var virtualAssistant = VirtualAssistant(dcx, vaElm, lang);
            }
        } else {
            window.requestAnimationFrame(isDomLoaded);
        }
    };

    window.requestAnimationFrame(isDomLoaded);
}();

},{"../lib/js/polyfills.js":1,"./components/virtual-assistant/":14,"./css/index.css":19,"./project.config.js":23,"./resources/":24,"dcx-wasabi":4,"promise-polyfill":9}],21:[function(require,module,exports){
module.exports = "{{##def.ele:param: {{? param.type == 'question'}}\n<div class=\"cxco-chatElement--question\">\n    {{=param.value}}\n</div>\n\n\n{{?? param.type == 'answer'}}\n<div class=\"cxco-chatElement--answer\">\n    {{=param.value}}\n</div>\n\n<div data-dcx-feedbackbox=\"a.{{=param.id}}\" >\n    <form class=\"feedbackBox\">\n\n        <div class=\"feedbackSelection\">\n            <div class=\"feedbackTitle\">{{=it.feedback.title || 'empty'}}</div>\n            <div class=\"feedbackoptions etclearfix\">\n                <label class=\"option optionyes\">\n                            <input type=\"radio\" class=\"optioninput\" \n                            title=\"{{=it.feedback.option1.text}}\" name=\"etoption\" data-dcx-feedbackbox-option \n                            data-score=\"{{=it.feedback.option1.score}}\" \n                            data-label=\"{{=it.feedback.option1.label}}\">{{=it.feedback.option1.text}}\n                        </label>\n                <label class=\"option optionno\">\n                            <input type=\"radio\" title=\"{{=it.feedback.option2.text}}\" name=\"etoption\" data-dcx-feedbackbox-option data-score=\"{{=it.feedback.option2.score}}\" data-label=\"{{=it.feedback.option2.label}}\">{{=it.feedback.option2.text}}\n                        </label>\n            </div>\n        </div>\n\n        <div class=\"feedbacktextcontainer\">\n            <ul class=\"feedbackdropdown\" data-dcx-feedbackbox-dropdown>\n                <li>\n                    <div class=\"feedbackprefix\">Erkennung</div>\n                    <span>Meine Frage wurde <b>nicht richtig verstanden</b></span>\n                </li>\n                <li>\n                    <div class=\"feedbackprefix\">Information</div>\n                    <span>Die Antwort <b>stimmt inhaltlich nicht</b></span>\n                </li>\n                <li>\n                    <div class=\"feedbackprefix\">L&ouml;sung</div>\n                    <span>Die vorgeschlagene <b>L&ouml;sung funktioniert nicht</b></span>\n                </li>\n                <li data-toggle-feedback=\"1\">\n                    <div class=\"feedbackprefix\">Sonstiges</div>\n                    <span><b>Beschreibe kurz</b> das Problem: ...</span>\n                </li>\n            </ul>\n        </div>\n\n        <div class=\"feedbackcomment etclearfix\">\n            <div class=\"feedbackcommenttitle\"><b>Beschreibe kurz</b> das Problem:</div>\n            <textarea class=\"feedbacktextarea\" rows=\"3\" cols=\"50\" maxlength=\"400\"></textarea>\n            <div class=etfeedbackcommentbuttons>\n                <button class=\"feedbackprevious\" type=\"button\">Zur&uuml;ck</button>\n                <button class=\"submitfeedback\" type=\"button\" disabled>Senden</button>\n            </div>\n        </div>\n\n        <div class=\"etthanks\">\n            <div class=\"etthankspositive\">\n                Vielen Dank!\n            </div>\n            <div class=\"etthanksnegative\">\n                Entschuldige bitte, dass wir dein Anliegen bis hierher noch nicht lösen konnten.<br> Hast du schon versucht,\n                deine Frage genauer zu beschreiben oder anders zu formulieren?<br> Ansonsten hilft dir gern unser <a target=\"_blank\" href=\"https://www.congstar.de/hilfe-service/kontakt/\">Kundenservice</a>                weiter.\n            </div>\n        </div>\n\n    </form>\n</div>\n{{?}} #}} {{~it.chat :chat:index}}\n\n<div class=\"cxco-chatElement element_{{=index}}\">\n    {{#def.ele:chat }}\n</div>\n{{~}}";

},{}],22:[function(require,module,exports){
'use strict';

var chatTpl = require('./chat.tpl');
//const initFeedbackBox = require('../../components/feedback-box/index.js');
var initDropdown = require('../../components/feedback-box/dropdown.js');
var debug = require('debug')('cxco:plugin.chat');
var basicLightbox = require('basiclightbox');

module.exports = function (dcx, va, lang) {

    var chatElement = null;
    var chatTemplate = dcx.dot.template(chatTpl);
    var language = lang;

    /**
     * Initialize chat component
     * @param {HTMLElement} el
     */
    function init(el) {

        debug('init');

        va.storage.store('chat-history', []);

        if (dcx.utils.isString(el)) {

            chatElement = document.createElement(el);
        } else if (dcx.utils.isElement(el)) {

            chatElement = el;
        }

        refreshTemplate();
    }

    /**
     * Adds question to storage and refreshes template
     * @param {Object} options
     */
    function addQuestion(options) {

        //empty questions not allowed
        //todo this should be rejected on the VA
        if (options.question.replace(/\s/g, '').length > 0) {
            var properties = {};
            if (options.dialogPath) {

                var level = options.dialogPath.indexOf('/') >= 0 ? options.dialogPath.split('/').length - 1 : 0;

                properties = {
                    isDialog: true,
                    dialogLevel: level,
                    dialogPath: options.dialogPath
                };
            }
            addToStorage({
                value: options.question
            }, 'question', undefined, properties);

            refreshTemplate();
        }
    }

    /**
     * Adds Answer to storage and refreshes template
     *
     * @param {Object} engineResult
     */
    function addAnswer(engineResult) {

        if (engineResult.answer) {
            var properties = {};
            if (engineResult.dialogPath) {

                var level = engineResult.dialogPath.indexOf('/') >= 0 ? engineResult.dialogPath.split('/').length - 1 : 0;

                properties = {
                    isDialog: true,
                    dialogLevel: level,
                    dialogId: engineResult.dialogId,
                    dialogPath: engineResult.dialogPath
                };

                try {
                    /*there might be the case where a dialog starts from a dialog answer, not inheriting the parent's path, so we need recalculate it's level.*/
                    properties.dialogParent = engineResult.context.session.dialogPath;

                    if (properties.dialogPath.indexOf(properties.dialogParent) < 0) {
                        properties.dialogLevel = getDialogLevel(engineResult.context.session.dialogPath) === 0 ? 1 + level : getDialogLevel(engineResult.context.session.dialogPath) + level;
                    }
                } catch (err) {}
            }

            addToStorage({
                value: engineResult.answer
            }, 'answer', engineResult.interactionId, properties);

            refreshTemplate();
        }
    }

    /**
     * Persists element in storage.
     * @param {Object} obj
     * @param {string} type
     * @param {string} id
     * @param {Object} properties
     */
    function addToStorage(obj, type, id, properties) {

        var chatHistoryStorage = va.storage.store('chat-history');
        var last = chatHistoryStorage[chatHistoryStorage.length - 1];

        if (dcx.utils.isUndefined(last)) {
            last = {};
        }

        if (!objectCompare(last, getDAO(obj, type))) {

            if (properties.isDialog && type == "answer") {

                var deleteFromIndex = chatHistoryStorage.length,
                    isToDelete = false;

                //starts from the most recent
                for (var i = chatHistoryStorage.length - 1; i >= 0; i--) {

                    var histIterator = chatHistoryStorage[i];

                    /**
                     * delete conditions:
                     * - the new element being from a same or lesser level
                     * - having the same parent dialog
                     * - having the same dialog id
                     * - being on a level > 0
                     */
                    if (properties.dialogLevel <= histIterator.properties.dialogLevel && properties.dialogParent == histIterator.properties.dialogParent && properties.dialogId == histIterator.properties.dialogId && properties.dialogLevel > 0) {

                        deleteFromIndex = i - 1;
                        isToDelete = true;
                        //console.log('delete at ' + deleteFromIndex);
                    }
                }

                if (isToDelete) {

                    chatHistoryStorage.splice(deleteFromIndex);
                    chatHistoryStorage.push(last);
                }
            }

            chatHistoryStorage.push(getDAO(obj, type, id, properties));
            va.storage.store('chat-history', chatHistoryStorage);
        }
    }

    /**
     * Gets the chat historic object
     * @returns {Object[]} chat history object
     */
    function loadFromStorage() {

        return va.storage.store('chat-history');
    }

    /**
     * renders the template using the chat history
     */
    function refreshTemplate() {

        debug('refreshTemplate');

        var storageHistoric = loadFromStorage();

        var templateData = Object.assign({}, {
            chat: storageHistoric
        }, language);

        chatElement.innerHTML = chatTemplate(templateData);

        postProcessTemplate();
    }

    /**
     * Adds lightbox, event listeners, etc after DOM has been updated.
     */
    function postProcessTemplate() {

        var nodeList = chatElement.querySelectorAll('.cxco-chatElement');

        var _loop = function _loop(i, nodLen) {

            var currentElement = nodeList[i];
            var videos = currentElement.querySelectorAll('.cxco-video');

            if (videos.length > 0) {
                var _loop2 = function _loop2(j, imgLen) {

                    videos[j].addEventListener('click', function () {
                        debug('show lightbox');
                        var src = videos[j].getAttribute('data-src');
                        var html = '<div class="basicLightbox__close"><svg viewBox="0 0 16 16"><path d="M1.75 0C1.2992168 0 .87666344.18583656.53125.53125c-.69082688.6908269-.69082688 1.7779231 0 2.46875l5 5-5 5c-.69082688.690827-.69082688 1.777923 0 2.46875.6908269.690827 1.7779231.690827 2.46875 0l5-5 5 5c.690827.690827 1.777923.690827 2.46875 0 .690827-.690827.690827-1.777923 0-2.46875l-5-5 5-5c.690827-.6908269.690827-1.7779231 0-2.46875-.690827-.69082688-1.777923-.69082688-2.46875 0l-5 5-5-5C2.6545866.18583656 2.2007832 0 1.75 0z"></path></svg></div>' + '<iframe src="' + src + '" height="360px" width="640px">';

                        var instance = basicLightbox.create(html);
                        instance.show();
                        var closeBtn = instance.element().querySelector('.basicLightbox__close');

                        if (window.screen.availWidth < 640) {

                            var iframe = instance.element().querySelector('iframe');
                            iframe.width = window.screen.availWidth - 20;
                            //4:3 ratio
                            iframe.height = 3 * iframe.width / 4;
                        }

                        closeBtn.addEventListener('click', function () {
                            debug('close lightbox');
                            instance.close();
                        });
                    });
                };

                for (var j = 0, imgLen = videos.length; j < imgLen; j++) {
                    _loop2(j, imgLen);
                }
            }
        };

        for (var i = 0, nodLen = nodeList.length; i < nodLen; i++) {
            _loop(i, nodLen);
        }
    }

    /**
     * Creates a new object from a value and a type
     *
     * @param {Object} obj
     * @param {string} type
     * @param {string} id - interactionId
     * @param {Object} properties - optional
     *
     * @returns {Object}
     */
    function getDAO(obj, type, id, properties) {

        return {
            id: id,
            value: obj.value,
            type: type,
            properties: properties
        };
    }

    /**
     * Compare two objects, matching type and value.
     *
     * @param {Object} a
     * @param {Object} b
     */
    function objectCompare(a, b) {

        return a.value == b.value && a.type == b.type;
    }

    /**
     * Gets last question element class name from storage
     * */
    function getLastQuestionElement() {

        var last = va.storage.store('chat-history').length;

        return last >= 2 ? "element_" + (last - 2) : "element_0";
    }

    /**
     * Gets element at index i from the chat history
     * @param {integer} i
     */
    function getElementAt(i) {

        try {

            return va.storage.store('chat-history')[i];
        } catch (err) {

            //console.log('error - chatbox getElementAt: ' + err);
            return undefined;
        }
    }

    /**
     * Adds Feedback component to element
     * @param {htmlelement} element
     * @param {string} id
     */
    function addFeedback(element, id) {

        return initDropdown(dcx, element, id, va);
    }

    /**
     * Returns the level  based on the dialogpath
     * @param {string} dialogpath
     * @returns {Number} level
     */
    function getDialogLevel(dialogpath) {
        return dialogpath.split('/').length - 1;
    }

    return {

        init: init,
        addQuestion: addQuestion,
        addAnswer: addAnswer,
        getLastQuestionElement: getLastQuestionElement,
        addFeedback: addFeedback
    };
};

},{"../../components/feedback-box/dropdown.js":11,"./chat.tpl":21,"basiclightbox":2,"debug":6}],23:[function(require,module,exports){
'use strict';

var config = JSON.parse('{"mode":""}');

module.exports = {

    project: {

        apiKey: '032d719f-0a06-4d3c-80ab-dbab6bbb5fe1',
        culture: 'de',
        customerKey: 'Congstar',
        key: 'CONGSTAR'
    },
    context: {

        interaction: {},
        session: {
            mode: config.mode
        },
        user: {},
        dim: {
            //Internal: 'Review',
            Channels: 'ServiceLayer'
        }
    },
    timeout: 20000,
    storage: {
        storageType: 'sessionStorage'
    }
};

},{}],24:[function(require,module,exports){
'use strict';

var resources = {'de': require('./lang/de.js'),'nl': require('./lang/nl.js')};

module.exports = function (lang) {
  return resources[lang];
};

},{"./lang/de.js":25,"./lang/nl.js":26}],25:[function(require,module,exports){
'use strict';

module.exports = {

    va: {
        title: 'Waarmee kunnen we je helpen?'
    },
    backbutton: {
        text: 'Terug'
    },
    input: {
        placeholder: 'Suchbegriff eingeben'
    },
    submitbutton: {
        text: 'Vraag'
    },
    feedback: {
        title: 'War diese Antwort hilfreich?',
        comment: {
            placeholder: 'Typ hier uw feedback...'
        },
        submit: 'Verstuur',
        reply: 'Bedankt voor je feedback',
        option1: {
            text: 'Ja',
            label: 'Ja',
            score: 1
        },
        option2: {
            text: 'Nein',
            label: 'Nein',
            score: -1
        }
    },
    categoryBox: {
        title: 'Of kies een onderwerp waar we klanten vaak mee helpen',
        stepTitle1: 'Over welke verzekering gaat je vraag?',
        stepTitle2: 'Selecteer de categorie',
        stepTitle3: 'Selecteer het onderwerp',
        stepTitle4: 'Klik op de vraag om het antwoord in te zien',
        moduleZorg: 'Zorgverzekering',
        moduleOther: 'Andere verzekeringen'
    }
};

},{}],26:[function(require,module,exports){
'use strict';

module.exports = {

    va: {
        title: 'Waarmee kunnen we je helpen?'
    },
    backbutton: {
        text: 'Terug'
    },
    input: {
        placeholder: 'Stel je vraag'
    },
    submitbutton: {
        text: 'Vraag'
    },
    feedback: {
        title: 'Bent u tevreden met dit antwoord?',
        comment: {
            placeholder: 'Typ hier uw feedback...'
        },
        submit: 'Verstuur',
        reply: 'Bedankt voor je feedback',
        option1: {
            text: 'Ja',
            label: 'Ja',
            score: 1
        },
        option2: {
            text: 'Nee, ik wil graag contact',
            label: 'Nee, ik wil graag contact',
            score: -1
        }
    },
    categoryBox: {
        title: 'Of kies een onderwerp waar we klanten vaak mee helpen',
        stepTitle1: 'Over welke verzekering gaat je vraag?',
        stepTitle2: 'Selecteer de categorie',
        stepTitle3: 'Selecteer het onderwerp',
        stepTitle4: 'Klik op de vraag om het antwoord in te zien',
        moduleZorg: 'Zorgverzekering',
        moduleOther: 'Andere verzekeringen'
    }
};

},{}],27:[function(require,module,exports){
'use strict';

var debug = require('debug')('cxco:utils');

module.exports = function () {

    function formatDialogOptions(element) {

        var dialogOptionLinks = Array.prototype.slice.call(element.querySelectorAll('.dialog-option-link'));
        if (dialogOptionLinks.length > 0) {

            dialogOptionLinks.forEach(function (link) {

                link.parentNode.className = 'dialog-option';
                link.parentNode.parentNode.className = 'dialog-options';
            });
        }
    }

    function replaceImages(engineResult, outputbox) {

        if (Array.isArray(engineResult.images)) {

            engineResult.images.forEach(function (img) {

                var additionalData = img.additionalData || {};

                // get the factor the image should be sized to
                var sizeFactor = additionalData.imageWidth ? parseFloat(img.additionalData.imageWidth) : 1;

                // get the alignment class (left/center/right)
                var alignment = additionalData.imageAlign ? img.additionalData.imageAlign : 'left';

                // convert it to a percentage
                var imageWidth = sizeFactor * 100;
                var url = '';

                if (img.templateName.toLowerCase() == 'imgix') {

                    // calculate the max size of the image relative to the outputbox
                    var maxWidth = Math.round(Math.max(outputbox.clientWidth, outputbox.offsetWidth) * sizeFactor);
                    var maxHeight = Math.round(parseInt(img.crop[3]) / parseInt(img.crop[2]) * maxWidth);

                    url = 'https://digitalcx.imgix.net/' + img.name + '?fit=crop&rect=' + img.crop.join(',') + '&w=' + maxWidth + '&h=' + maxHeight;
                } else if (img.templateName.toLowerCase() == 'default') {

                    // for a default template name property is the full url
                    url = img.name;
                }

                // replace the image tags in the content
                var pattern = new RegExp('%\\{Image\\(' + img.id + '\\)\\}', 'gi');
                var imgHtml = '<img src="' + url + '" title="' + (img.title || '') + '" alt="' + (img.title || '') + '" class="image image_' + alignment + '" width="' + imageWidth + '%" />';

                engineResult.answer = engineResult.answer.replace(pattern, imgHtml);
            });
        }
    }

    function replaceVideos(engineResult, outputbox) {

        // default dimensions of a video
        var defaultWidth = 640;
        var defaultHeight = 360;

        if (Array.isArray(engineResult.videos)) {

            engineResult.videos.forEach(function (video) {

                var additionalData = video.additionalData || {};

                // get the factor the video should be sized to
                var sizeFactor = additionalData.videoWidth ? parseFloat(video.additionalData.videoWidth) : 1;

                // get the alignment class (left/center/right)
                var alignment = additionalData.videoAlign ? video.additionalData.videoAlign : 'left';

                // get the videoId
                var videoId = additionalData.videoId ? video.additionalData.videoId : '';

                // convert it to a percentage
                var imageWidth = sizeFactor * 100;

                // calculate the max size of the video relative to the outputbox
                var maxWidth = Math.round(Math.max(outputbox.clientWidth, outputbox.offsetWidth) * sizeFactor);
                var widthFactor = defaultWidth > maxWidth ? maxWidth / defaultWidth : defaultWidth / maxWidth;
                var maxHeight = Math.round(widthFactor * defaultHeight);

                // set the proper embed url based on the source
                var url = '',
                    thumbnail = '';

                if (video.source.toLowerCase() == 'youtube') {

                    url = 'https://www.youtube.com/embed/' + videoId;
                    thumbnail = '<img class="cxco-video" src="https://img.youtube.com/vi/' + videoId + '/0.jpg" data-src="' + url + '">';
                } else if (video.source.toLowerCase() == 'vimeo') {

                    url = 'https://player.vimeo.com/video/' + videoId;
                }

                // replace the video tags in the content
                var pattern = new RegExp('%\\{Video\\(' + video.id + '\\)\\}', 'gi');
                var videoHtml = '<iframe src="' + url + '" class="video video_' + alignment + '" style="height:' + maxHeight + 'px;width:' + maxWidth + 'px;" frameborder="0"></iframe>';

                engineResult.answer = thumbnail != '' ? engineResult.answer.replace(pattern, thumbnail) : engineResult.answer.replace(pattern, videoHtml);
            });
        }
    }

    /**
     * Appends thumbnails from outputadditions to the answer.
     * @param {Object} engineResult
     */
    function addThumbnails(engineResult) {

        var additions = engineResult.additions;

        if (additions.hasOwnProperty('videolink')) {

            var videoAddition = JSON.parse(additions.videolink.replace(/``/g, '"'));

            if (!Array.isArray(videoAddition)) {

                videoAddition = [videoAddition];
            }

            var youtubePatt = new RegExp(['(?:http|https|)(?::\\/\\/|)(?:www.|)(?:yout', 'u\\.be\\/|youtube\\.com(?:\\/embed\\/|\\/v\\', '/|\\/watch\\?v=|\\/ytscreeningroom\\?v=|\\/f', 'eeds\\/api\\/videos\\/|\\/user\\S*[^\\w\\-\\', 's]|\\S*[^\\w\\-\\s]))([\\w\\-]*)'].join(''), 'g');

            for (var i = 0; i < videoAddition.length; i++) {

                youtubePatt.lastIndex = 0;
                var videoUrl = 'https://www.youtube.com/embed/' + youtubePatt.exec(videoAddition[i].youtubeUrl)[1] + '?rel=0';

                engineResult.answer += '<div><img class="cxco-video" src="' + videoAddition[i].youtubeThumb + '" data-src="' + videoUrl + '"></div>';
            }
        }

        if (additions.hasOwnProperty('imagelink')) {

            var imageAddition = JSON.parse(additions.imagelink.replace(/``/g, '"'));

            if (!Array.isArray(imageAddition)) {

                imageAddition = [imageAddition];
            }

            for (var i = 0; i < imageAddition.length; i++) {

                engineResult.answer += '<div><img class="cxco-image" src="' + imageAddition[i].imageThumb + '" ></div>';
            }
        }
    }

    /**
     * Adds media content to the answer
     * @param {Object} engineResult
     * @param {HTMLElement} outputbox
     */
    function replaceMedia(engineResult, outputbox) {

        if (engineResult.images.length > 0) {

            replaceImages(engineResult, outputbox);
        }

        if (engineResult.videos.length > 0) {

            replaceVideos(engineResult, outputbox);
        }

        if (engineResult.additions.hasOwnProperty('videolink') || engineResult.additions.hasOwnProperty('imagelink')) {

            try {
                addThumbnails(engineResult);
            } catch (e) {
                debug('error:', e);
            }
        }
    }

    function isOldiOs() {
        return (/(iPad|iPhone);.*CPU.*OS (5|6|7)_\d/i.test(navigator.userAgent)
        );
    }

    /**
     * Find the classificationId and Category id for the current URL given a list.
     * @param {Object[]} pageBasedMapping
     */
    function getPageBasedSettings(pageBasedMapping) {
        var pageBasedFaqSettings = void 0;

        var defaultPageBasedFaqs = {
            classificationId: 97,
            categoryId: 738
        };

        try {

            var currentPage = location.href.replace(location.protocol + '//', '');
            var isProduction = location.hostname.includes('congstar');
            var isStaging = location.hostname.includes('nicotua');

            if (!isProduction && !isStaging) {
                currentPage = location.href.split('url=')[1] || currentPage;
            }
            var found = pageBasedMapping.find(function (item) {
                return item.url.test(currentPage.toLowerCase()) === true;
            });

            pageBasedFaqSettings = found ? found.settings : defaultPageBasedFaqs;
        } catch (err) {
            //default
            debug('error:', err);
            pageBasedFaqSettings = defaultPageBasedFaqs;
        }

        return pageBasedFaqSettings;
    }

    return {

        formatDialogOptions: formatDialogOptions,
        replaceImages: replaceImages,
        replaceVideos: replaceVideos,
        isOldiOs: isOldiOs,
        replaceMedia: replaceMedia,
        getPageBasedSettings: getPageBasedSettings
    };
};

},{"debug":6}]},{},[20])(20)
});
